import React, { useState, useEffect, useCallback } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import PhoneIcon from "@mui/icons-material/Phone";
import AreasService from "../services/AreasService";
import LaboratoriosService from "../services/LaboratoriosService";
import EstudiosService from "../services/EstudiosService";
import MaterialesService from "../services/MaterialesService";
import ParametrosEstudioService from "../services/ParametrosEstudioService";
import EstudiosIntService from "../services/EstudiosIntService";
import SinonimosService from "../services/SinonimosService";
import MuestrasService from "../services/MuestrasService";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveIcon from "@mui/icons-material/Remove";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CachedIcon from "@mui/icons-material/Cached";
import CancelIcon from "@mui/icons-material/Cancel";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import withReactContent from "sweetalert2-react-content";
import { mostrarToast } from "../utils/toastUtils";
import { ejecutarConCargandoPDF } from "../utils/pdfLoadingUtils";
import { filterAndRankEstudios } from "../utils/estudioFilterUtils";
import header from "../img/header-informeResultados.png";
import {
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  Tabs,
  Tab,
  IconButton,
  Tooltip,
  tooltipClasses,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Autocomplete,
} from "@mui/material";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import EstudiosSubService from "../services/EstudiosSubService";

const normStr = (s) => String(s || "").trim().toUpperCase();

const isSubEstudioFlag = (estObj) => {
  if (!estObj) return false;
  const val = estObj.registroExamenSub ?? estObj.registro_examen_sub ?? estObj.esSubexamen ?? estObj.isSubEstudio;
  if (val === true || val === 1 || String(val) === "1" || String(val).toUpperCase() === "SI" || String(val).toLowerCase() === "true") {
    return true;
  }
  return false;
};

const TabPanel = ({ children, value, index }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`tabpanel-${index}`}
    aria-labelledby={`tab-${index}`}
  >
    {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
  </div>
);

const useValidatedInputChange = (setter, errorSetter) =>
  useCallback(
    (event) => {
      const value = event.target.value;
      setter(value);

      if (errorSetter && value !== "") {
        errorSetter(false);
      }
    },
    [setter, errorSetter],
  );

const useInputChange = (setter) =>
  useCallback((event) => setter(event.target.value), [setter]);

const useDirectChange = (setter) =>
  useCallback((value) => setter(value), [setter]);

const serializarParametrosParaBackend = (paramsList) => {
  if (!paramsList) return [];
  return paramsList.map((p, idx) => {
    const ordenVal = p.orden !== undefined && p.orden !== null ? p.orden : idx + 1;
    if (p.tipoReferencia === "mixto") {
      const { nuevoValorInput, valorSeleccionadoList, ...rest } = p;
      const listMapped = (p.valoresPosibles || []).map(val => ({
        valor: val,
        esPredeterminado: p.valorPredeterminado === val
      }));
      return {
        ...rest,
        orden: ordenVal,
        mixto: listMapped,
        valoresParametro: listMapped
      };
    }
    return { ...p, orden: ordenVal };
  });
};

const extractIntervalos = (p) => {
  if (!p) return [];

  const parseIfArrayOrJSON = (val) => {
    if (Array.isArray(val)) return val;
    if (typeof val === "string" && val.trim() !== "") {
      const trimmed = val.trim();
      if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
        try {
          const parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) return parsed;
          if (parsed && Array.isArray(parsed.intervalosBr)) return parsed.intervalosBr;
          if (parsed && Array.isArray(parsed.intervalosBR)) return parsed.intervalosBR;
          if (parsed && Array.isArray(parsed.intervalos)) return parsed.intervalos;
        } catch (e) {
          return [];
        }
      }
    }
    return [];
  };

  const sources = [
    p.intervalosBr,
    p.intervalosBR,
    p.intervalos,
    p.intervalos_br,
    p.valoresParametro,
    p.valoresReferencia,
    p.valorReferencia,
    p.valor_referencia,
  ];

  for (const src of sources) {
    const res = parseIfArrayOrJSON(src);
    if (res.length > 0) return res;
  }

  return [];
};

const deserializarParametrosParaBackend = (paramsList) => {
  if (!paramsList) return [];
  const listCopy = [...paramsList];
  const hasOrden = listCopy.some((p) => p && (p.orden !== undefined && p.orden !== null && Number(p.orden) > 0));
  if (hasOrden) {
    listCopy.sort((a, b) => Number(a.orden || 0) - Number(b.orden || 0));
  }
  return listCopy.map(p => {
    const listIntervalos = extractIntervalos(p);
    let cleanValorRef = p.valorReferencia;
    if (typeof cleanValorRef === "string" && cleanValorRef.trim().startsWith("[")) {
      cleanValorRef = "";
    }
    if (p.tipoReferencia === "mixto") {
      const listSource = p.valoresParametro || p.mixto;
      if (Array.isArray(listSource)) {
        return {
          ...p,
          intervalosBR: listIntervalos,
          valoresPosibles: listSource.map(item => item.valor),
          valorPredeterminado: (listSource.find(item => item.esPredeterminado === true || item.esPredeterminado === "true" || item.esPredeterminado === 1) || {}).valor || "",
          nuevoValorInput: "",
          valorSeleccionadoList: ""
        };
      }
      if (cleanValorRef && cleanValorRef.trim().startsWith("{")) {
        try {
          const parsed = JSON.parse(cleanValorRef);
          return {
            ...p,
            intervalosBR: listIntervalos,
            valoresPosibles: parsed.valoresPosibles || [],
            valorPredeterminado: parsed.valorPredeterminado || "",
            valorReferencia: parsed.valorReferencia || "",
            nuevoValorInput: "",
            valorSeleccionadoList: ""
          };
        } catch (e) {
          // fall through
        }
      }
      return {
        ...p,
        intervalosBR: listIntervalos,
        valoresPosibles: p.valoresPosibles || [],
        valorPredeterminado: p.valorPredeterminado || "",
        nuevoValorInput: "",
        valorSeleccionadoList: ""
      };
    }
    return {
      ...p,
      intervalosBR: listIntervalos,
      valoresPosibles: p.valoresPosibles || [],
      valorPredeterminado: p.valorPredeterminado || "",
      nuevoValorInput: "",
      valorSeleccionadoList: ""
    };
  });
};

const formatIntervaloBR = (intervalo, unidadMedida) => {
  if (intervalo === null || intervalo === undefined) return "";
  if (typeof intervalo === "string" || typeof intervalo === "number") {
    return String(intervalo).trim();
  }

  const getVal = (...keys) => {
    for (const k of keys) {
      if (intervalo[k] !== undefined && intervalo[k] !== null && String(intervalo[k]).trim() !== "") {
        return intervalo[k];
      }
    }
    return "";
  };

  let genRaw = (getVal("genero", "sexo") || "").toLowerCase().trim();
  let generoStr = "";
  if (genRaw === "ambos" || genRaw === "ambas") {
    generoStr = "Ambos";
  } else if (genRaw === "hombre" || genRaw === "masculino" || genRaw === "m") {
    generoStr = "Hombre";
  } else if (genRaw === "mujer" || genRaw === "femenino" || genRaw === "f") {
    generoStr = "Mujer";
  } else if (genRaw !== "") {
    generoStr = genRaw.charAt(0).toUpperCase() + genRaw.slice(1);
  }

  const edadMin = getVal("edadMin", "edad_min", "edadInicial", "edad_inicial");
  const edadMax = getVal("edadMax", "edad_max", "edadFinal", "edad_final");
  const tipoEdad = String(getVal("tipoEdad", "tipo_edad", "unidadEdad", "unidad_edad") || "años").toLowerCase();

  let edadStr = "";
  if (edadMin !== "" && edadMax !== "") {
    edadStr = `${edadMin} a ${edadMax} ${tipoEdad}`;
  } else if (edadMin !== "") {
    edadStr = `> ${edadMin} ${tipoEdad}`;
  } else if (edadMax !== "") {
    edadStr = `< ${edadMax} ${tipoEdad}`;
  }

  const minVal = getVal("intervaloMin", "intervalo_min", "minimo", "min", "valMin", "val_min");
  const maxVal = getVal("intervaloMax", "intervalo_max", "maximo", "max", "valMax", "val_max");
  const unitStr = unidadMedida || getVal("unidadMedida", "unidad_medida", "um");
  const unit = unitStr ? ` ${unitStr}` : "";

  let rangoStr = "";
  if (minVal !== "" && maxVal !== "") {
    rangoStr = `${minVal} - ${maxVal}${unit}`;
  } else if (minVal !== "") {
    rangoStr = `> ${minVal}${unit}`;
  } else if (maxVal !== "") {
    rangoStr = `< ${maxVal}${unit}`;
  }

  if (!rangoStr && !edadStr) {
    const rawVal = getVal("valor", "valorReferencia", "valor_referencia", "texto", "descripcion");
    if (rawVal) return String(rawVal).trim();
  }

  if (!generoStr && (edadStr || rangoStr)) {
    generoStr = "Ambos";
  }

  const parts = [generoStr, edadStr, rangoStr].filter(Boolean);
  return parts.join("  ");
};

const getCleanValorReferencia = (p) => {
  if (!p) return "";
  let val = p.valorReferencia || p.valor_referencia || p.valorPredeterminado || "";
  if (typeof val === "string" && val.trim().startsWith("{")) {
    try {
      const parsed = JSON.parse(val);
      if (parsed.valorReferencia) return parsed.valorReferencia;
      if (parsed.valorPredeterminado) return parsed.valorPredeterminado;
    } catch (e) {
      // keep original val
    }
  }
  if (typeof val === "string" && val.trim().startsWith("[")) {
    try {
      const parsed = JSON.parse(val);
      if (Array.isArray(parsed) && parsed.length > 0) {
        const lines = parsed.map((i) => formatIntervaloBR(i, p.unidadMedida)).filter(Boolean);
        if (lines.length > 0) return ["***", ...lines].join("\n");
      }
    } catch (e) {
      // keep original
    }
  }
  return val;
};

const Estudios = () => {
  useEffect(() => {
    async function init() {
      document.title = "Estudios";
      try {
        getAreas();
        getLaboratorios();
        getMateriales();
        getEstudios();
      } catch (error) {
        console.error("Error inicializando Estudios:", error);
      }
    }

    init();
  }, []);

  const htmlToPlainText = (raw) => {
    if (!raw) return "";
    let str = String(raw);
    str = str
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<p[^>]*>/gi, "")
      .replace(/<li[^>]*>/gi, "• ")
      .replace(/<\/li>/gi, "\n")
      .replace(/<\/?ul[^>]*>/gi, "")
      .replace(/<\/?ol[^>]*>/gi, "")
      .replace(/<\/?\w+[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"');
    return str
      .split("\n")
      .map((l) => l.trim())
      .filter((l) => l !== "")
      .join("\n");
  };

  const formatParametroIntervalos = (p) => {
    if (!p) return "";
    const listIntervalos = extractIntervalos(p);

    if (Array.isArray(listIntervalos) && listIntervalos.length > 0) {
      const lines = listIntervalos.map((i) => formatIntervaloBR(i, p.unidadMedida)).filter(Boolean);
      if (lines.length > 0) {
        return ["***", ...lines].join("\n");
      }
    }
    const cleanVal = getCleanValorReferencia(p);
    const rawText = cleanVal || p.valorReferencia || p.valor_referencia || p.valorPredeterminado || "";
    return htmlToPlainText(rawText);
  };

  const unwrapParamObj = (item) => {
    if (!item) return {};
    if (item.parametro && typeof item.parametro === "object") return unwrapParamObj(item.parametro);
    if (item.item && typeof item.item === "object") return unwrapParamObj(item.item);
    return item;
  };

  const generarPDF = async (estudioObj) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    const logoWidth = 180;
    const logoHeight = 25;

    const centerX = (pageWidth - logoWidth) / 2;

    doc.addImage(header, "PNG", centerX, 10, logoWidth, logoHeight);

    let targetEstudioId = null;
    if (typeof estudioObj === "number" || typeof estudioObj === "string") {
      targetEstudioId = estudioObj;
    } else if (estudioObj && (estudioObj.idEstudio || estudioObj.id_estudio || estudioObj.id)) {
      targetEstudioId = estudioObj.idEstudio || estudioObj.id_estudio || estudioObj.id;
    } else {
      targetEstudioId = selectedEstudioId;
    }

    const targetNombre = (estudioObj && typeof estudioObj === "object" ? estudioObj.nombre : null) || nombre || "";
    const targetMetodo = (estudioObj && typeof estudioObj === "object" ? estudioObj.metodo : null) || metodo || "";
    const targetObservaciones = (estudioObj && typeof estudioObj === "object" ? estudioObj.observaciones : null) || observacionesEstudio || "";

    let mainParams = [];
    if (targetEstudioId) {
      try {
        const rawMain = await ParametrosEstudioService.getParametrosPorEstudio(targetEstudioId);
        if (Array.isArray(rawMain) && rawMain.length > 0) {
          mainParams = deserializarParametrosParaBackend(rawMain);
        } else {
          mainParams = deserializarParametrosParaBackend(parametros || []);
        }
      } catch (err) {
        mainParams = deserializarParametrosParaBackend(parametros || []);
      }
    } else {
      mainParams = deserializarParametrosParaBackend(parametros || []);
    }

    const paramItemsMapByEstudio = {};

    const setParamsForEstudio = (id, paramsList) => {
      if (id === null || id === undefined) return;
      const cleanParams = (paramsList || []).map((p) => unwrapParamObj(p));
      paramItemsMapByEstudio[id] = cleanParams;
      paramItemsMapByEstudio[String(id)] = cleanParams;
      paramItemsMapByEstudio[Number(id)] = cleanParams;
    };

    const getParamsForEstudio = (id) => {
      if (id === null || id === undefined) return [];
      return paramItemsMapByEstudio[id] || paramItemsMapByEstudio[String(id)] || paramItemsMapByEstudio[Number(id)] || [];
    };

    const effectiveTargetId = targetEstudioId || "local_preview";
    setParamsForEstudio(effectiveTargetId, mainParams);

    const cargarNodoRecursivo = async (estNodo, idPadre = null) => {
      const idEstNode = estNodo.idEstudio || estNodo.id || estNodo.id_estudio;
      let detEst = estNodo;
      if (idEstNode && idEstNode !== "local_preview") {
        try {
          const fetched = await EstudiosService.getEstudioPorId(idEstNode);
          if (fetched) detEst = { ...estNodo, ...fetched };
        } catch (e) { }
      }

      if (idEstNode && getParamsForEstudio(idEstNode).length === 0) {
        try {
          const rawParams = (await ParametrosEstudioService.getParametrosPorEstudio(idEstNode)) || [];
          if (Array.isArray(rawParams) && rawParams.length > 0) {
            setParamsForEstudio(idEstNode, deserializarParametrosParaBackend(rawParams));
          }
        } catch (e) { }
      }

      let rawInt = [];
      if (idEstNode && idEstNode !== "local_preview") {
        try {
          rawInt = (await EstudiosIntService.getEstudiosPorEstudio(idEstNode)) || [];
        } catch (e) { }
      }

      if (
        (!rawInt || rawInt.length === 0) &&
        (idEstNode === effectiveTargetId || String(idEstNode) === String(effectiveTargetId)) &&
        Array.isArray(estudiosLista) &&
        estudiosLista.length > 0
      ) {
        rawInt = estudiosLista;
      }

      const hijosNodos = [];
      for (const sub of rawInt) {
        const idSec = sub.idEstudioSec || sub.idEstudio || sub.id_estudio_sec || sub.id;
        if (!idSec) continue;
        try {
          let subDet = null;
          try {
            subDet = await EstudiosService.getEstudioPorId(idSec);
          } catch (e) { }

          const fallbackNombre = sub.nombre || (nombres.find((n) => String(n.idEstudio) === String(idSec))?.nombre) || "ESTUDIO INTEGRADO";
          if (!subDet) {
            subDet = { ...sub, idEstudio: idSec, nombre: fallbackNombre };
          } else {
            subDet = { ...subDet, ...sub, idEstudio: idSec, nombre: subDet.nombre || fallbackNombre };
          }
          const nodeHijo = await cargarNodoRecursivo(subDet, idEstNode);
          hijosNodos.push(nodeHijo);
        } catch (e) {
          console.error("Error cargando sub-estudio integrado:", e);
        }
      }

      return {
        estudio: detEst,
        idPadre: idPadre,
        hijos: hijosNodos,
      };
    };

    const generarTablasPDF = (node) => {
      const tablas = [];
      const est = node.estudio || {};
      const idE = est.idEstudio || est.id || est.id_estudio;
      const params = getParamsForEstudio(idE);
      const hijos = node.hijos || [];
      const esSub = isSubEstudioFlag(est);
      const tieneParamsMain = params.length > 0;
      const tieneHijos = hijos.length > 0;

      if (esSub && node.idPadre !== null) {
        if (tieneParamsMain) {
          tablas.push({
            nombreTitulo: (est.nombre || "").toUpperCase(),
            estudioPrincipalTabla: est,
            rows: params.map((p) => ({ type: "parameter", item: p })),
          });
          for (const child of hijos) {
            tablas.push(...generarTablasPDF(child));
          }
        } else {
          if (tieneHijos) {
            const primerHijo = hijos[0];
            const tablasPrimerHijo = generarTablasPDF(primerHijo);
            if (tablasPrimerHijo.length > 0) {
              const primeraTabla = tablasPrimerHijo[0];
              primeraTabla.nombreHeaderSuperior = (est.nombre || "").toUpperCase();
              if (!primeraTabla.estudioPrincipalTabla) {
                primeraTabla.estudioPrincipalTabla = primerHijo.estudio;
              }
              tablas.push(...tablasPrimerHijo);
            } else {
              tablas.push({
                nombreTitulo: (est.nombre || "").toUpperCase(),
                estudioPrincipalTabla: est,
                rows: [],
              });
            }
            for (let i = 1; i < hijos.length; i++) {
              tablas.push(...generarTablasPDF(hijos[i]));
            }
          } else {
            tablas.push({
              nombreTitulo: (est.nombre || "").toUpperCase(),
              estudioPrincipalTabla: est,
              rows: [],
            });
          }
        }
      } else {
        const rowsBox = [];
        if (tieneParamsMain) {
          params.forEach((p) => rowsBox.push({ type: "parameter", item: p }));
        }

        const agregarSubEstudiosMismaTabla = (n) => {
          for (const child of n.hijos || []) {
            const childEst = child.estudio || {};
            const esSubFlag = isSubEstudioFlag(childEst);
            if (esSubFlag) continue;

            const childIdE = childEst.idEstudio || childEst.id || childEst.id_estudio;
            const childParams = getParamsForEstudio(childIdE);
            const firstParamObj = unwrapParamObj(childParams[0]);
            const firstParamName = firstParamObj.parametro || firstParamObj.nombre || firstParamObj.nombreParametro || "";

            const esMismoNombreUnicoParam =
              !esSubFlag &&
              childParams.length === 1 &&
              normStr(childEst.nombre) === normStr(firstParamName);

            if (!esMismoNombreUnicoParam) {
              rowsBox.push({
                type: "subHeader",
                nombre: (childEst.nombre || "").toUpperCase(),
              });
            }

            childParams.forEach((p) => rowsBox.push({ type: "parameter", item: p }));

            if ((child.hijos || []).length > 0) {
              if (!isSubEstudioFlag(childEst)) {
                agregarSubEstudiosMismaTabla(child);
              }
            }
          }
        };

        agregarSubEstudiosMismaTabla(node);

        tablas.push({
          nombreTitulo: (est.nombre || "").toUpperCase(),
          estudioPrincipalTabla: est,
          rows: rowsBox,
        });

        const agregarSubTablasAparte = (n) => {
          for (const child of n.hijos || []) {
            if (isSubEstudioFlag(child.estudio)) {
              tablas.push(...generarTablasPDF(child));
            } else if ((child.hijos || []).length > 0) {
              agregarSubTablasAparte(child);
            }
          }
        };
        agregarSubTablasAparte(node);
      }

      return tablas;
    };

    const targetObj = (estudioObj && typeof estudioObj === "object")
      ? { ...estudioObj, idEstudio: estudioObj.idEstudio || estudioObj.id_estudio || estudioObj.id || effectiveTargetId, nombre: estudioObj.nombre || targetNombre }
      : { idEstudio: effectiveTargetId, nombre: targetNombre };

    const arbolMain = await cargarNodoRecursivo(targetObj, null);
    const tablasPDFList = generarTablasPDF(arbolMain);

    const bodyRows = [];
    const todosLosParams = Object.values(paramItemsMapByEstudio).flat().map((p) => unwrapParamObj(p));
    const tieneIntervalosBR = todosLosParams.some((p) => {
      const tipoRef = (p.tipoReferencia || p.tipoReferenciaParametro || p.tipoValor || "").toLowerCase();
      return tipoRef === "intervalobr" || tipoRef === "intervalosbr" || tipoRef === "intervalo" || extractIntervalos(p).length > 0;
    });

    const renderColumnSubHeader = () => {
      if (tieneIntervalosBR) {
        return [
          { content: "", styles: { fillColor: [109, 143, 123] } },
          { content: "Bajo", styles: { fillColor: [109, 143, 123], textColor: [0, 0, 0], fontStyle: "bold", halign: "center", cellPadding: 1 } },
          { content: "Dentro", styles: { fillColor: [109, 143, 123], textColor: [0, 0, 0], fontStyle: "bold", halign: "center", cellPadding: 1 } },
          { content: "Sobre", styles: { fillColor: [109, 143, 123], textColor: [0, 0, 0], fontStyle: "bold", halign: "center", cellPadding: 1 } },
          { content: "Intervalo Biológico de Referencia", styles: { fillColor: [109, 143, 123], textColor: [0, 0, 0], fontStyle: "bold", halign: "center", cellPadding: 1 } },
        ];
      } else {
        return [
          { content: "", styles: { fillColor: [109, 143, 123] } },
          { content: "Resultado", colSpan: 3, styles: { fillColor: [109, 143, 123], textColor: [0, 0, 0], fontStyle: "bold", halign: "center", cellPadding: 1 } },
          { content: "Intervalo Biológico de Referencia", styles: { fillColor: [109, 143, 123], textColor: [0, 0, 0], fontStyle: "bold", halign: "center", cellPadding: 1 } },
        ];
      }
    };

    bodyRows.push(renderColumnSubHeader());

    if (tablasPDFList.length > 0) {
      tablasPDFList.forEach((tablaData, tIdx) => {
        if (tablaData.nombreHeaderSuperior) {
          bodyRows.push([
            {
              content: tablaData.nombreHeaderSuperior,
              colSpan: 5,
              isSubHeader: true,
              styles: {
                fontStyle: "bolditalic",
                halign: "left",
                fillColor: [245, 245, 245],
                textColor: [0, 0, 0],
                cellPadding: 3,
              },
            },
          ]);
        }

        if (tIdx > 0 && tablaData.nombreTitulo) {
          bodyRows.push([
            {
              content: tablaData.nombreTitulo,
              colSpan: 5,
              isSubHeader: true,
              styles: {
                fontStyle: "bolditalic",
                halign: "left",
                fillColor: [245, 245, 245],
                textColor: [0, 0, 0],
                cellPadding: 3,
              },
            },
          ]);
        }

        (tablaData.rows || []).forEach((rObj) => {
          if (rObj.type === "subHeader") {
            bodyRows.push([
              {
                content: (rObj.nombre || "").toUpperCase(),
                colSpan: 5,
                isSubHeader: true,
                styles: {
                  fontStyle: "bolditalic",
                  halign: "left",
                  fillColor: [245, 245, 245],
                  textColor: [0, 0, 0],
                  cellPadding: 3,
                },
              },
            ]);
          } else if (rObj.type === "parameter") {
            const p = unwrapParamObj(rObj.item);
            const paramNombre = (p.parametro || p.nombre || p.nombreParametro || p.parametroNombre || "").toUpperCase();
            if (!paramNombre) return;

            const refTexto = formatParametroIntervalos(p);
            const tipoRef = (p.tipoReferencia || "").toLowerCase();
            const esBR = tipoRef === "intervalobr" || tipoRef === "intervalosbr" || tipoRef === "intervalo" || extractIntervalos(p).length > 0;

            if (esBR) {
              bodyRows.push([
                { content: paramNombre, styles: { halign: "left", fontStyle: "normal" } },
                { content: "", styles: { halign: "center" } },
                { content: "XX", styles: { halign: "center" } },
                { content: "", styles: { halign: "center" } },
                { content: refTexto, styles: { halign: "center" } },
              ]);
            } else {
              bodyRows.push([
                { content: paramNombre, styles: { halign: "left", fontStyle: "normal" } },
                { content: "XX", colSpan: 3, styles: { halign: "center" } },
                { content: refTexto, styles: { halign: "center" } },
              ]);
            }

            if (p.textoExtra && htmlToPlainText(p.textoExtra).trim() !== "") {
              bodyRows.push([
                {
                  content: htmlToPlainText(p.textoExtra),
                  colSpan: 5,
                  styles: { halign: "left", fontStyle: "normal", cellPadding: 2 },
                },
              ]);
            }
          }
        });
      });
    } else if (Array.isArray(mainParams) && mainParams.length > 0) {
      mainParams.forEach((pRaw) => {
        const p = unwrapParamObj(pRaw);
        const paramNombre = (p.parametro || p.nombre || p.nombreParametro || p.parametroNombre || "").toUpperCase();
        if (!paramNombre) return;

        const refTexto = formatParametroIntervalos(p);
        const tipoRef = (p.tipoReferencia || "").toLowerCase();
        const esBR = tipoRef === "intervalobr" || tipoRef === "intervalosbr" || tipoRef === "intervalo" || extractIntervalos(p).length > 0;

        if (esBR) {
          bodyRows.push([
            { content: paramNombre, styles: { halign: "left", fontStyle: "normal" } },
            { content: "", styles: { halign: "center" } },
            { content: "XX", styles: { halign: "center" } },
            { content: "", styles: { halign: "center" } },
            { content: refTexto, styles: { halign: "center" } },
          ]);
        } else {
          bodyRows.push([
            { content: paramNombre, styles: { halign: "left", fontStyle: "normal" } },
            { content: "XX", colSpan: 3, styles: { halign: "center" } },
            { content: refTexto, styles: { halign: "center" } },
          ]);
        }

        if (p.textoExtra && p.textoExtra.trim() !== "") {
          bodyRows.push([
            {
              content: htmlToPlainText(p.textoExtra),
              colSpan: 5,
              styles: { halign: "left", fontStyle: "normal", cellPadding: 2 },
            },
          ]);
        }
      });
    }

    autoTable(doc, {
      startY: 40,
      tableWidth: 180,
      margin: { left: 14 },
      head: [
        [
          {
            content: (targetNombre || nombre || "INFORME DE RESULTADOS").toUpperCase(),
            colSpan: 5,
            styles: {
              fillColor: [93, 122, 104],
              textColor: [255, 255, 255],
              fontStyle: "bold",
              fontSize: 11,
              halign: "left",
            },
          },
        ],
      ],
      body: bodyRows,
      styles: {
        fontSize: 9,
        overflow: "linebreak",
        halign: "center",
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      headStyles: {
        fillColor: [93, 122, 104],
        textColor: [255, 255, 255],
        halign: "left",
        fontStyle: "bold",
        fontSize: 11,
        lineWidth: 0.5,
      },
      bodyStyles: { fillColor: [255, 255, 255] },
      alternateRowStyles: { fillColor: [255, 255, 255] },
      columnStyles: {
        0: { halign: "left", cellWidth: 55 },
        1: { halign: "center", cellWidth: 14 },
        2: { halign: "center", cellWidth: 18 },
        3: { halign: "center", cellWidth: 15 },
        4: { halign: "center", cellWidth: 78 },
      },
      didDrawCell: (data) => {
        if (data.section === "body" && data.cell.raw && data.cell.raw.isSubHeader) {
          const { cell } = data;
          const { x, y, width, height } = cell;
          doc.setFont(cell.styles.font, cell.styles.fontStyle);
          doc.setFontSize(cell.styles.fontSize);
          const text = cell.text ? cell.text[0] : "";
          if (text && text.trim() !== "") {
            const textWidth = doc.getTextWidth(text);
            const startX = x + cell.padding("left");
            const underlineY = y + height - cell.padding("bottom") - 1;
            doc.setLineWidth(0.5);
            doc.setDrawColor(0, 0, 0);
            doc.line(startX, underlineY, startX + textWidth, underlineY);
          }
        }
      },
    });

    let currentY = doc.lastAutoTable.finalY + 5;

    const obsText = htmlToPlainText(observacionesEstudio || "");
    if (obsText && obsText.trim() !== "") {
      doc.setFont(undefined, "bold");
      doc.setFontSize(9);
      doc.text("Observaciones:", 14, currentY);
      const obsTitleWidth = doc.getTextWidth("Observaciones:");

      doc.setFont(undefined, "normal");
      const obsLines = doc.splitTextToSize(obsText, pageWidth - 28 - obsTitleWidth - 2);
      if (obsLines.length === 1) {
        doc.text(obsLines[0], 14 + obsTitleWidth + 2, currentY);
        currentY += 6;
      } else {
        doc.text(obsLines, 14 + obsTitleWidth + 2, currentY);
        currentY += obsLines.length * 4.5 + 2;
      }
    }

    doc.setFont(undefined, "bold");
    doc.setFontSize(9);
    const labelMetodologia = "Metodología:";
    doc.text(labelMetodologia, 14, currentY);
    const widthMetLabel = doc.getTextWidth(labelMetodologia);

    doc.setFont(undefined, "normal");
    const valMetodologia = metodo || "";
    doc.text(valMetodologia, 14 + widthMetLabel + 2, currentY);
    const widthMetVal = doc.getTextWidth(valMetodologia);

    const labelEspecimen = "Espécimen:";
    const xEspecimen = 14 + widthMetLabel + 2 + widthMetVal + 15;
    doc.setFont(undefined, "bold");
    doc.text(labelEspecimen, xEspecimen, currentY);
    const widthEspLabel = doc.getTextWidth(labelEspecimen);

    doc.setFont(undefined, "normal");
    const tipoMuestraTexto = etiquetas?.[0]?.tipoMuestra || "";
    doc.text(tipoMuestraTexto, xEspecimen + widthEspLabel + 2, currentY);

    currentY += 7;

    doc.setFont(undefined, "italic");
    doc.setFontSize(8);
    doc.text(
      "*** Aquellos valores de referencia marcados con asterisco, solo aparecerá el valor de acuerdo a la edad y sexo del paciente",
      14,
      currentY,
      { maxWidth: pageWidth - 28 }
    );

    return doc.output("blob");
  };
  function renderQuillHTML(doc, html, x, y, maxWidth) {
    // Normalizar espacios y saltos
    let content = html
      .replace(/&nbsp;/g, " ")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<p[^>]*>/gi, "");

    // Manejo de listas
    content = content
      .replace(/<li[^>]*>/gi, "• ")
      .replace(/<\/li>/gi, "\n")
      .replace(/<\/?ul[^>]*>/gi, "")
      .replace(/<\/?ol[^>]*>/gi, "");

    // Dividir por líneas
    const lines = content.split("\n");
    let offsetY = y;

    lines.forEach((line) => {
      let text = line.trim();
      if (!text) {
        offsetY += 5;
        return;
      }

      // Reset estilo por defecto
      doc.setFont(undefined, "normal");
      doc.setFontSize(9);

      // Encabezados <h1>–<h6>
      if (/<h[1-6]>/i.test(line)) {
        doc.setFont(undefined, "bold");
        doc.setFontSize(12);
        text = text.replace(/<\/?h[1-6]>/gi, "");
      }

      // Negrita
      if (/<strong>|<b>/i.test(line)) {
        doc.setFont(undefined, "bold");
        text = text.replace(/<\/?strong>|<\/?b>/gi, "");
      }

      // Cursiva
      if (/<em>|<i>/i.test(line)) {
        doc.setFont(undefined, "italic");
        text = text.replace(/<\/?em>|<\/?i>/gi, "");
      }

      // Subrayado
      if (/<u>/i.test(line)) {
        text = text.replace(/<\/?u>/gi, "");
        doc.text(text, x, offsetY, { maxWidth });
        const textWidth = doc.getTextWidth(text);
        doc.line(x, offsetY + 1, x + textWidth, offsetY + 1);
        offsetY += 5;
        return;
      }

      // Enlaces <a>
      if (/<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/i.test(line)) {
        const match = line.match(/<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/i);
        if (match) {
          const url = match[1];
          const label = match[2];
          doc.setTextColor(0, 0, 255);
          doc.text(label, x, offsetY, { maxWidth });
          const textWidth = doc.getTextWidth(label);
          doc.line(x, offsetY + 1, x + textWidth, offsetY + 1); // subrayado estilo link
          doc.setTextColor(0, 0, 0);
          offsetY += 5;
          return;
        }
      }

      // Quitar etiquetas restantes
      text = text.replace(/<\/?[^>]+(>|$)/g, "");

      // Dibujar texto
      doc.text(text, x, offsetY, { maxWidth });
      offsetY += 5;
    });

    return offsetY; // devuelve la última posición Y para continuar
  }

  const [activeTab, setActiveTab] = useState(0);
  const [activeTabMuestras, setActiveTabMuestras] = useState(0);
  const navigate = useNavigate();
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleTabMuestrasChange = (event, newValue) => {
    setActiveTabMuestras(newValue);
  };

  function mostrarMensaje(mensaje) {
    mostrarToast(mensaje, "success");
  }


  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }
  const mostrarPDF = async (estudioParam) => {
    try {
      await ejecutarConCargandoPDF(
        async () => {
          const blob = await generarPDF(estudioParam);
          const url = URL.createObjectURL(blob);

          Swal.fire({
            title: "Informe de Resultados",
            html: `<iframe src="${url}" width="100%" height="500px" style="border:none;"></iframe>`,
            width: "80%",
            showCloseButton: true,
            showConfirmButton: false,
          });
        },
        "Generando la estructura y parámetros del estudio...",
        "Procesando reporte de estudio"
      );
    } catch (error) {
      console.error("Error al generar vista previa de PDF:", error);
      mostrarError("No se pudo generar la vista previa del PDF.");
    }
  };

  function reloadPage() {
    window.location.reload();
  }

  const [sinonimos, setSinonimos] = useState([]);
  const [areas, setAreas] = useState([]);
  const MySwal = withReactContent(Swal);
  const agregarArea = () => {
    handleCrearNuevoArea();
  };

  const agregarLaboratorio = () => {
    handleCrearNuevoLabRef();
  };
  async function handleCrearNuevoArea() {
    let areasOriginal = [];
    let areasActivos = [];

    const resultado = await AreasService.getAreas();
    areasOriginal = resultado.data.areas;
    areasActivos = [...areasOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (area) => {
      return area
        .map(
          (ar, idx) => `
      <tr style="background:${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom:1px solid #e2e8f0; transition:background-color 0.15s ease;" onmouseover="this.style.backgroundColor='#f1f5f9'" onmouseout="this.style.backgroundColor='${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}'">
        <td style="padding:10px 14px; text-align:left; font-weight:600; color:#1e293b; font-size:13px;">
          <span style="display:inline-block; padding:2px 8px; font-size:11px; font-weight:700; background:#e0f2fe; color:#0369a1; border-radius:4px; margin-right:6px;">${escapeHtml(ar.abreviatura || "-")}</span>
          ${escapeHtml(ar.nombre || "")}
        </td>
        <td style="padding:8px 4px; text-align:center; width:60px;">
          <button data-action="editar" data-idarea="${ar.idArea}" title="Editar" style="background:#fef3c7; color:#d97706; border:1px solid #fde68a; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer; transition:all 0.2s;">
            <i class="fas fa-edit"></i>
          </button>
        </td>
        <td style="padding:8px 4px; text-align:center; width:60px;">
          <button data-action="eliminar" data-idarea="${ar.idArea}" title="Eliminar" style="background:#fee2e2; color:#dc2626; border:1px solid #fecaca; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer; transition:all 0.2s;">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
    `,
        )
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginaAreas = areasActivos.slice(inicio, fin);
      const tabla = document.getElementById("tablaAreas");
      if (tabla) {
        if (!paginaAreas || paginaAreas.length === 0) {
          tabla.innerHTML = `<tr><td colspan="3" style="text-align:center; padding:24px; color:#64748b; font-weight:500;">No hay registros encontrados</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginaAreas);
        }
        // Delegación de eventos en la tabla para manejar editar/eliminar
        // Esto evita problemas al re-renderizar filas dinámicamente
        tabla.onclick = (e) => {
          const btn = e.target.closest("button[data-action]");
          if (!btn || !tabla.contains(btn)) return;
          const action = btn.dataset.action;
          const id = btn.dataset.idarea;

          if (action === "editar") {
            const area = areasOriginal.find(
              (item) => String(item.idArea) === String(id),
            );
            if (!area) return;
            const tr = btn.closest("tr");
            if (!tr) return;

            const originalHTML = tr.innerHTML;
            tr.innerHTML = `
      <td style="padding:10px 14px; text-align:left;">
        <div style="display:flex; gap:10px; align-items:center; flex-wrap:wrap;">
          <div>
            <label style="font-weight:600; font-size:11px; color:#475569; display:block; margin-bottom:2px;">Abreviatura:</label>
            <input id="input-edit-abreviatura" style="width:90px; padding:5px 8px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px;" value="${escapeHtml(area.abreviatura || "")}" />
          </div>
          <div style="flex:1;">
            <label style="font-weight:600; font-size:11px; color:#475569; display:block; margin-bottom:2px;">Nombre:</label>
            <input id="input-edit-nombre" style="width:100%; min-width:140px; padding:5px 8px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px;" value="${escapeHtml(area.nombre || "")}" />
          </div>
        </div>
      </td>
      <td style="padding:8px 4px; text-align:center;">
        <button class="btn-save" title="Guardar" style="background:#dcfce7; color:#16a34a; border:1px solid #bbf7d0; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer;">
          <i class="fas fa-check"></i>
        </button>
      </td>
      <td style="padding:8px 4px; text-align:center;">
        <button class="btn-cancel" title="Cancelar" style="background:#f1f5f9; color:#64748b; border:1px solid #cbd5e1; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer;">
          <i class="fas fa-times"></i>
        </button>
      </td>
    `;

            const inputNombre = tr.querySelector("#input-edit-nombre");
            const inputAbreviatura = tr.querySelector(
              "#input-edit-abreviatura",
            );
            const btnSave = tr.querySelector(".btn-save");
            const btnCancel = tr.querySelector(".btn-cancel");

            btnCancel.addEventListener("click", () => {
              tr.innerHTML = originalHTML;
              renderPagina(paginaActual);
            });

            btnSave.addEventListener("click", async () => {
              const nuevoNombre = inputNombre.value.trim();
              const nuevoAbreviatura = inputAbreviatura.value.trim();
              if (!nuevoNombre) {
                Swal.showValidationMessage("El nombre es obligatorio");
                return;
              }
              Swal.resetValidationMessage();

              const idxOriginal = areasOriginal.findIndex(
                (it) => String(it.idArea) === String(id),
              );
              if (idxOriginal !== -1) {
                areasOriginal[idxOriginal] = {
                  ...areasOriginal[idxOriginal],
                  abreviatura: nuevoAbreviatura,
                  nombre: nuevoNombre,
                };
              }
              const idxAct = areasActivos.findIndex(
                (it) => String(it.idArea) === String(id),
              );
              if (idxAct !== -1) {
                areasActivos[idxAct] = {
                  ...areasActivos[idxAct],
                  abreviatura: nuevoAbreviatura,
                  nombre: nuevoNombre,
                };
              }

              try {
                let areaToUpdate = {
                  abreviaturaN: nuevoAbreviatura,
                  nombreN: nuevoNombre,
                  estatusN: "A",
                };
                await AreasService.updateArea(areaToUpdate, id);
                Swal.fire({
                  icon: "success",
                  title: "Guardado",
                  timer: 1200,
                  showConfirmButton: false,
                });
                const resultado = await AreasService.getAreas();
                setAreas(resultado.data.areas);
                areasOriginal = resultado.data.areas;
                areasActivos = [...areasOriginal];
                renderPagina(paginaActual);
              } catch (err) {
                console.error("Error al guardar area:", err);
                Swal.fire({
                  icon: "error",
                  title: "Error al guardar",
                  text: "Intenta de nuevo",
                });
              }
            });
          } else if (action === "eliminar") {
            const id = btn.dataset.idarea;
            const area = areasOriginal.find(
              (item) => String(item.idArea) === String(id),
            );
            if (area) {
              Swal.fire({
                title: "¿Eliminar area?",
                text: `¿Desea eliminar al area ${area.nombre}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar",
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await eliminarArea(area.idArea);
                }
              });
            }
          }
        };
      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(areasActivos.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${areasActivos.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.5" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.5" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "ÁREAS",
      width: "55rem",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
      <div style="display:flex; gap:10px; align-items:flex-end; margin-bottom:15px; flex-wrap:wrap;">
        <div>
          <label for="swal-abreviatura" style="font-weight:600; font-size:12px; color:#475569; display:block; margin-bottom:4px; text-align:left;">Abreviatura:</label>
          <input id="swal-abreviatura" style="width:110px; padding:7px 10px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px; outline:none;" placeholder="Ej. BIO" />
        </div>
        <div style="flex:1; min-width:180px;">
          <label for="swal-nombre" style="font-weight:600; font-size:12px; color:#475569; display:block; margin-bottom:4px; text-align:left;">Nombre:</label>
          <input id="swal-nombre" style="width:100%; box-sizing:border-box; padding:7px 10px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px; outline:none;" placeholder="Nombre del área..." />
        </div>
        <button id="btnAgregarArea" style="background:linear-gradient(135deg, #0f4b75 0%, #006787 100%); color:white; border:none; border-radius:6px; padding:8px 16px; font-weight:600; font-size:13px; cursor:pointer; display:inline-flex; align-items:center; gap:6px; height:34px; box-shadow:0 2px 4px rgba(0,0,0,0.15);">
          <i class="fas fa-plus"></i> Agregar área
        </button>
      </div>

      <div style="border:1px solid #cbd5e1; border-radius:8px; overflow:hidden; box-shadow:0 4px 6px -1px rgba(0,0,0,0.08); background:white;">
        <table class="tablaAreas" style="width:100%; border-collapse:collapse; text-align:center;">
          <thead>
            <tr style="background:linear-gradient(180deg, #0f4b75 0%, #006787 100%); color:white; font-size:13px;">
              <th style="padding:10px 14px; text-align:left; font-weight:600;">Área</th>
              <th style="padding:10px 4px; font-weight:600; width:60px;">Editar</th>
              <th style="padding:10px 4px; font-weight:600; width:60px;">Eliminar</th>
            </tr>
          </thead>
          <tbody id="tablaAreas">
            
          </tbody>
        </table>
      </div>

      <div style="margin-top:14px; display:flex; justify-content:space-between; align-items:center;">
        <span id="paginaActual" style="font-weight:600; font-size:13px; color:#475569;"></span>
        <div style="display:flex; gap:8px;">
          <button id="btnAnterior" style="background:#006787; color:white; border:none; border-radius:6px; padding:6px 14px; font-weight:600; font-size:12px; cursor:pointer; display:inline-flex; align-items:center; gap:4px; box-shadow:0 1px 2px rgba(0,0,0,0.1);">
            <i class="fas fa-chevron-left" style="font-size:10px;"></i> Anterior
          </button>
          <button id="btnSiguiente" style="background:#006787; color:white; border:none; border-radius:6px; padding:6px 14px; font-weight:600; font-size:12px; cursor:pointer; display:inline-flex; align-items:center; gap:4px; box-shadow:0 1px 2px rgba(0,0,0,0.1);">
            Siguiente <i class="fas fa-chevron-right" style="font-size:10px;"></i>
          </button>
        </div>
      </div>
    `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });

        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (paginaActual < Math.ceil(areasActivos.length / porPagina)) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnAgregarArea")
          .addEventListener("click", async () => {
            try {
              const nombreVal = document.getElementById("swal-nombre").value.trim();
              const abreviaturaVal = document.getElementById("swal-abreviatura").value.trim();
              if (!nombreVal) {
                Swal.showValidationMessage("El nombre es obligatorio");
                return;
              }
              Swal.resetValidationMessage();
              let area = {
                abreviatura: abreviaturaVal,
                nombre: nombreVal,
                estatus: "A",
              };
              let resultado = await AreasService.agregarArea(area);
              resultado = await AreasService.getAreas();
              setAreas(resultado.data.areas);
              areasOriginal = resultado.data.areas;
              areasActivos = [...areasOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
              document.getElementById("swal-abreviatura").value = "";
              document.getElementById("swal-nombre").value = "";
            } catch (error) {
              console.error("Error al recargar areas:", error);
            }
          });
      },
    });
  }

  const eliminarArea = async (areaId) => {
    try {
      const resultado = await AreasService.deleteArea(areaId);
      if (resultado.data.estatus === "OK") {
        mostrarMensaje("Area eliminada con éxito!");
        getAreas();
      } else {
        mostrarError("Error al eliminar area");
      }
    } catch (error) {
      console.error("Error al eliminar area:", error);
      mostrarError("Error al eliminar area");
    }
  };

  async function handleCrearNuevoLabRef() {
    let laboratoriosOriginal = [];
    let laboratoriosActivos = [];

    const resultado = await LaboratoriosService.getLaboratorios();
    laboratoriosOriginal = resultado.data.laboratorios;
    laboratoriosActivos = [...laboratoriosOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (laboratorio) => {
      return laboratorio
        .map(
          (lab, idx) => `
      <tr style="background:${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom:1px solid #e2e8f0; transition:background-color 0.15s ease;" onmouseover="this.style.backgroundColor='#f1f5f9'" onmouseout="this.style.backgroundColor='${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}'">
        <td style="padding:10px 14px; text-align:left; font-weight:600; color:#1e293b; font-size:13px;">
          <span style="display:inline-block; padding:2px 8px; font-size:11px; font-weight:700; background:#e0f2fe; color:#0369a1; border-radius:4px; margin-right:6px;">${escapeHtml(lab.abreviatura || "-")}</span>
          ${escapeHtml(lab.nombre || "")}
        </td>
        <td style="padding:8px 4px; text-align:center; width:60px;">
          <button data-action="editar" data-idlaboratorio="${lab.idLaboratorio}" title="Editar" style="background:#fef3c7; color:#d97706; border:1px solid #fde68a; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer; transition:all 0.2s;">
            <i class="fas fa-edit"></i>
          </button>
        </td>
        <td style="padding:8px 4px; text-align:center; width:60px;">
          <button data-action="eliminar" data-idlaboratorio="${lab.idLaboratorio}" title="Eliminar" style="background:#fee2e2; color:#dc2626; border:1px solid #fecaca; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer; transition:all 0.2s;">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
    `,
        )
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginasLaboratorios = laboratoriosActivos.slice(inicio, fin);
      const tabla = document.getElementById("tablaLaboratorios");
      if (tabla) {
        if (!paginasLaboratorios || paginasLaboratorios.length === 0) {
          tabla.innerHTML = `<tr><td colspan="3" style="text-align:center; padding:24px; color:#64748b; font-weight:500;">No hay registros encontrados</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginasLaboratorios);
        }
        tabla.onclick = (e) => {
          const btn = e.target.closest("button[data-action]");
          if (!btn || !tabla.contains(btn)) return;
          const action = btn.dataset.action;
          const id = btn.dataset.idlaboratorio;

          if (action === "editar") {
            const laboratorio = laboratoriosOriginal.find(
              (item) => String(item.idLaboratorio) === String(id),
            );
            if (!laboratorio) return;

            const tr = btn.closest("tr");
            if (!tr) return;

            // Guardamos el HTML original por si cancelamos
            const originalHTML = tr.innerHTML;

            // Construimos inputs con los valores actuales (ajusta campos según tu modelo)
            tr.innerHTML = `
      <td style="padding:10px 14px; text-align:left;">
        <div style="display:flex; gap:10px; align-items:center; flex-wrap:wrap;">
          <div>
            <label style="font-weight:600; font-size:11px; color:#475569; display:block; margin-bottom:2px;">Abreviatura:</label>
            <input id="input-edit-abreviaturaLab" style="width:90px; padding:5px 8px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px;" value="${escapeHtml(laboratorio.abreviatura || "")}" />
          </div>
          <div style="flex:1;">
            <label style="font-weight:600; font-size:11px; color:#475569; display:block; margin-bottom:2px;">Nombre:</label>
            <input id="input-edit-nombreLab" style="width:100%; min-width:140px; padding:5px 8px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px;" value="${escapeHtml(laboratorio.nombre || "")}" />
          </div>
        </div>
      </td>
      <td style="padding:8px 4px; text-align:center;">
        <button class="btn-saveLab" title="Guardar" style="background:#dcfce7; color:#16a34a; border:1px solid #bbf7d0; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer;">
          <i class="fas fa-check"></i>
        </button>
      </td>
      <td style="padding:8px 4px; text-align:center;">
        <button class="btn-cancelLab" title="Cancelar" style="background:#f1f5f9; color:#64748b; border:1px solid #cbd5e1; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer;">
          <i class="fas fa-times"></i>
        </button>
      </td>
    `;

            // Obtener referencias a los nuevos controles
            const inputNombre = tr.querySelector("#input-edit-nombreLab");
            const inputAbreviatura = tr.querySelector(
              "#input-edit-abreviaturaLab",
            );
            const btnSave = tr.querySelector(".btn-saveLab");
            const btnCancel = tr.querySelector(".btn-cancelLab");

            // Cancelar: restaurar HTML original
            btnCancel.addEventListener("click", () => {
              tr.innerHTML = originalHTML;
              // reattach listeners (re-render la página para simplificar)
              renderPagina(paginaActual);
            });

            // Guardar: validar, actualizar arreglo y opcionalmente llamar al servicio
            btnSave.addEventListener("click", async () => {
              const nuevoNombre = inputNombre.value.trim();
              const nuevoAbreviatura = inputAbreviatura.value.trim();
              if (!nuevoNombre) {
                Swal.fire({
                  icon: "error",
                  title: "Nombre requerido",
                  timer: 1500,
                  showConfirmButton: false,
                });
                return;
              }

              // Actualizar en memoria
              const idxOriginal = laboratoriosOriginal.findIndex(
                (it) => String(it.idLaboratorio) === String(id),
              );
              if (idxOriginal !== -1) {
                laboratoriosOriginal[idxOriginal] = {
                  ...laboratoriosOriginal[idxOriginal],
                  nombre: nuevoNombre,
                  abreviatura: nuevoAbreviatura,
                };
              }
              // Mantener areasActivos sincronizado
              const idxAct = laboratoriosActivos.findIndex(
                (it) => String(it.idArea) === String(id),
              );
              if (idxAct !== -1) {
                laboratoriosActivos[idxAct] = {
                  ...laboratoriosActivos[idxAct],
                  nombre: nuevoNombre,
                  abreviatura: nuevoAbreviatura,
                };
              }

              // Opcional: llamar al servicio para persistir
              try {
                let laboratorioUpdate = {
                  nombreN: nuevoNombre,
                  abreviaturaN: nuevoAbreviatura,
                  estatusN: "A",
                };
                await LaboratoriosService.updateLaboratorio(
                  laboratorioUpdate,
                  id,
                );
                Swal.fire({
                  icon: "success",
                  title: "Guardado",
                  timer: 1200,
                  showConfirmButton: false,
                });
                // Re-renderizar la página actual para reflejar cambios y re-attach listeners
                const resultado = await LaboratoriosService.getLaboratorios();
                setLaboratorios(resultado.data.laboratorios);
                laboratoriosOriginal = resultado.data.laboratorios;
                laboratoriosActivos = [...laboratoriosOriginal];
                renderPagina(paginaActual);
              } catch (err) {
                console.error("Error al guardar laboratorio:", err);
                Swal.fire({
                  icon: "error",
                  title: "Error al guardar",
                  text: "Intenta de nuevo",
                });
              }
            });
          } else if (action === "eliminar") {
            const id = btn.dataset.idlaboratorio;
            const laboratorio = laboratoriosOriginal.find(
              (item) => String(item.idLaboratorio) === String(id),
            );
            if (laboratorio) {
              Swal.fire({
                title: "¿Eliminar laboratorio?",
                text: `¿Desea eliminar al laboratorio ${laboratorio.nombre}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar",
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await eliminarLaboratorio(laboratorio.idLaboratorio);
                }
              });
            }
          }
        };
      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(laboratoriosActivos.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${laboratoriosActivos.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.5" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.5" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "LABORATORIOS DE REFERENCIA",
      width: "55rem",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
      <div style="display:flex; gap:10px; align-items:flex-end; margin-bottom:15px; flex-wrap:wrap;">
        <div style="flex:1; min-width:180px;">
          <label for="swal-nombreLab" style="font-weight:600; font-size:12px; color:#475569; display:block; margin-bottom:4px; text-align:left;">Nombre:</label>
          <input id="swal-nombreLab" style="width:100%; box-sizing:border-box; padding:7px 10px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px; outline:none;" placeholder="Nombre del laboratorio..." />
        </div>
        <div>
          <label for="swal-abreviaturaLab" style="font-weight:600; font-size:12px; color:#475569; display:block; margin-bottom:4px; text-align:left;">Abreviatura:</label>
          <input id="swal-abreviaturaLab" style="width:110px; padding:7px 10px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px; outline:none;" placeholder="Ej. CH" />
        </div>
        <button id="btnAgregarLab" style="background:linear-gradient(135deg, #0f4b75 0%, #006787 100%); color:white; border:none; border-radius:6px; padding:8px 16px; font-weight:600; font-size:13px; cursor:pointer; display:inline-flex; align-items:center; gap:6px; height:34px; box-shadow:0 2px 4px rgba(0,0,0,0.15);">
          <i class="fas fa-plus"></i> Agregar Lab. Ref.
        </button>
      </div>

      <div style="border:1px solid #cbd5e1; border-radius:8px; overflow:hidden; box-shadow:0 4px 6px -1px rgba(0,0,0,0.08); background:white;">
        <table class="tablaLaboratorios" style="width:100%; border-collapse:collapse; text-align:center;">
          <thead>
            <tr style="background:linear-gradient(180deg, #0f4b75 0%, #006787 100%); color:white; font-size:13px;">
              <th style="padding:10px 14px; text-align:left; font-weight:600;">Laboratorio</th>
              <th style="padding:10px 4px; font-weight:600; width:60px;">Editar</th>
              <th style="padding:10px 4px; font-weight:600; width:60px;">Eliminar</th>
            </tr>
          </thead>
          <tbody id="tablaLaboratorios">
            
          </tbody>
        </table>
      </div>

      <div style="margin-top:14px; display:flex; justify-content:space-between; align-items:center;">
        <span id="paginaActual" style="font-weight:600; font-size:13px; color:#475569;"></span>
        <div style="display:flex; gap:8px;">
          <button id="btnAnterior" style="background:#006787; color:white; border:none; border-radius:6px; padding:6px 14px; font-weight:600; font-size:12px; cursor:pointer; display:inline-flex; align-items:center; gap:4px; box-shadow:0 1px 2px rgba(0,0,0,0.1);">
            <i class="fas fa-chevron-left" style="font-size:10px;"></i> Anterior
          </button>
          <button id="btnSiguiente" style="background:#006787; color:white; border:none; border-radius:6px; padding:6px 14px; font-weight:600; font-size:12px; cursor:pointer; display:inline-flex; align-items:center; gap:4px; box-shadow:0 1px 2px rgba(0,0,0,0.1);">
            Siguiente <i class="fas fa-chevron-right" style="font-size:10px;"></i>
          </button>
        </div>
      </div>
    `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });

        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (
              paginaActual < Math.ceil(laboratoriosActivos.length / porPagina)
            ) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnAgregarLab")
          .addEventListener("click", async () => {
            try {
              let laboratorio = {
                nombre: document.getElementById("swal-nombreLab").value,
                abreviatura: document.getElementById("swal-abreviaturaLab")
                  .value,
                estatus: "A",
              };
              let resultado =
                await LaboratoriosService.agregarLaboratorio(laboratorio);
              resultado = await LaboratoriosService.getLaboratorios();
              setLaboratorios(resultado.data.laboratorios);
              laboratoriosOriginal = resultado.data.laboratorios;
              laboratoriosActivos = [...laboratoriosOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
              document.getElementById("swal-nombreLab").value = "";
              document.getElementById("swal-abreviaturaLab").value = "";
            } catch (error) {
              console.error("Error al recargar laboratorios:", error);
            }
          });
      },
    });
  }

  const eliminarLaboratorio = async (labId) => {
    try {
      const resultado = await LaboratoriosService.deleteLaboratorio(labId);
      if (resultado.data.estatus === "OK") {
        mostrarMensaje("Laboratorio eliminado con éxito!");
        getLaboratorios();
      } else {
        mostrarError("Error al eliminar laboratorio");
      }
    } catch (error) {
      console.error("Error al eliminar laboratorio:", error);
      mostrarError("Error al eliminar laboratorio");
    }
  };

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }
  const agregarSinonimo = useCallback(() => {
    setSinonimos((prev) => [...prev, ""]);
  }, []);

  const eliminarSinonimo = useCallback((index) => {
    setSinonimos((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const actualizarSinonimo = useCallback((index, valor) => {
    setSinonimos((prev) => {
      const nuevos = [...prev];
      if (typeof nuevos[index] === "object" && nuevos[index] !== null) {
        nuevos[index] = { ...nuevos[index], sinonimo: valor };
      } else {
        nuevos[index] = valor;
      }
      return nuevos;
    });
  }, []);

  async function handleCrearNuevoMaterial() {
    let materialesOriginal = [];
    let materialesActivos = [];

    const resultado = await MaterialesService.getMateriales();
    materialesOriginal = resultado.data.materiales;
    materialesActivos = [...materialesOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (material) => {
      return material
        .map(
          (mat, idx) => `
      <tr style="background:${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom:1px solid #e2e8f0; transition:background-color 0.15s ease;" onmouseover="this.style.backgroundColor='#f1f5f9'" onmouseout="this.style.backgroundColor='${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}'">
        <td style="padding:10px 14px; text-align:left; font-weight:600; color:#1e293b; font-size:13px;">${escapeHtml(mat.nombre || "")}</td>
        <td style="padding:10px 14px; text-align:left; color:#475569; font-size:13px;">${escapeHtml(mat.asociacion || "-")}</td>
        <td style="padding:8px 4px; text-align:center; width:60px;">
          <button data-action="editar" data-idmaterial="${mat.idMaterial}" title="Editar" style="background:#fef3c7; color:#d97706; border:1px solid #fde68a; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer; transition:all 0.2s;">
            <i class="fas fa-edit"></i>
          </button>
        </td>
        <td style="padding:8px 4px; text-align:center; width:60px;">
          <button data-action="eliminar" data-idmaterial="${mat.idMaterial}" title="Eliminar" style="background:#fee2e2; color:#dc2626; border:1px solid #fecaca; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer; transition:all 0.2s;">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
    `,
        )
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginasMateriales = materialesActivos.slice(inicio, fin);
      const tabla = document.getElementById("tablaMateriales");
      if (tabla) {
        if (!paginasMateriales || paginasMateriales.length === 0) {
          tabla.innerHTML = `<tr><td colspan="4" style="text-align:center; padding:24px; color:#64748b; font-weight:500;">No hay registros encontrados</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginasMateriales);
        }
        tabla.onclick = (e) => {
          const btn = e.target.closest("button[data-action]");
          if (!btn || !tabla.contains(btn)) return;
          const action = btn.dataset.action;
          const id = btn.dataset.idmaterial;

          if (action === "editar") {
            const material = materialesOriginal.find(
              (item) => String(item.idMaterial) === String(id),
            );
            if (!material) return;

            const tr = btn.closest("tr");
            if (!tr) return;

            // Guardamos el HTML original por si cancelamos
            const originalHTML = tr.innerHTML;

            // Construimos inputs con los valores actuales (ajusta campos según tu modelo)
            tr.innerHTML = `
      <td colspan="2" style="padding:10px 14px; text-align:left;">
        <div style="display:flex; gap:10px; align-items:center; flex-wrap:wrap;">
          <div style="flex:1; min-width:140px;">
            <label style="font-weight:600; font-size:11px; color:#475569; display:block; margin-bottom:2px;">Nombre:</label>
            <input id="input-edit-nombreMat" style="width:100%; box-sizing:border-box; padding:5px 8px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px;" value="${escapeHtml(material.nombre || "")}" />
          </div>
          <div style="width:110px;">
            <label style="font-weight:600; font-size:11px; color:#475569; display:block; margin-bottom:2px;">Asociación:</label>
            <input id="input-edit-asociacionMat" style="width:100%; box-sizing:border-box; padding:5px 8px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px;" value="${escapeHtml(material.asociacion || "")}" />
          </div>
        </div>
      </td>
      <td style="padding:8px 4px; text-align:center;">
        <button class="btn-saveMat" title="Guardar" style="background:#dcfce7; color:#16a34a; border:1px solid #bbf7d0; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer;">
          <i class="fas fa-check"></i>
        </button>
      </td>
      <td style="padding:8px 4px; text-align:center;">
        <button class="btn-cancelMat" title="Cancelar" style="background:#f1f5f9; color:#64748b; border:1px solid #cbd5e1; border-radius:6px; width:32px; height:32px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer;">
          <i class="fas fa-times"></i>
        </button>
      </td>
    `;

            // Obtener referencias a los nuevos controles
            const inputNombre = tr.querySelector("#input-edit-nombreMat");
            const inputAsociacion = tr.querySelector(
              "#input-edit-asociacionMat",
            );
            const btnSave = tr.querySelector(".btn-saveMat");
            const btnCancel = tr.querySelector(".btn-cancelMat");

            // Cancelar: restaurar HTML original
            btnCancel.addEventListener("click", () => {
              tr.innerHTML = originalHTML;
              // reattach listeners (re-render la página para simplificar)
              renderPagina(paginaActual);
            });

            // Guardar: validar, actualizar arreglo y opcionalmente llamar al servicio
            btnSave.addEventListener("click", async () => {
              const nuevoNombre = inputNombre.value.trim();
              const nuevoAsociacion = inputAsociacion.value.trim();
              if (!nuevoNombre) {
                Swal.fire({
                  icon: "error",
                  title: "Nombre requerido",
                  timer: 1500,
                  showConfirmButton: false,
                });
                return;
              }

              // Actualizar en memoria
              const idxOriginal = materialesOriginal.findIndex(
                (it) => String(it.idMaterial) === String(id),
              );
              if (idxOriginal !== -1) {
                materialesOriginal[idxOriginal] = {
                  ...materialesOriginal[idxOriginal],
                  nombre: nuevoNombre,
                  asociacion: nuevoAsociacion,
                };
              }
              // Mantener areasActivos sincronizado
              const idxAct = materialesActivos.findIndex(
                (it) => String(it.idMaterial) === String(id),
              );
              if (idxAct !== -1) {
                materialesActivos[idxAct] = {
                  ...materialesActivos[idxAct],
                  nombre: nuevoNombre,
                  asociacion: nuevoAsociacion,
                };
              }

              // Opcional: llamar al servicio para persistir
              try {
                let materialUpdate = {
                  nombreN: nuevoNombre,
                  asociacionN: nuevoAsociacion,
                  estatusN: "A",
                };
                await MaterialesService.updateMaterial(
                  materialUpdate,
                  id,
                );
                Swal.fire({
                  icon: "success",
                  title: "Guardado",
                  timer: 1200,
                  showConfirmButton: false,
                });
                // Re-renderizar la página actual para reflejar cambios y re-attach listeners
                const resultado = await MaterialesService.getMateriales();
                setMateriales(resultado.data.materiales);
                materialesOriginal = resultado.data.materiales;
                materialesActivos = [...materialesOriginal];
                renderPagina(paginaActual);
              } catch (err) {
                console.error("Error al guardar material:", err);
                Swal.fire({
                  icon: "error",
                  title: "Error al guardar",
                  text: "Intenta de nuevo",
                });
              }
            });
          } else if (action === "eliminar") {
            const id = btn.dataset.idmaterial;
            const material = materialesOriginal.find(
              (item) => String(item.idMaterial) === String(id),
            );
            if (material) {
              Swal.fire({
                title: "¿Eliminar material?",
                text: `¿Desea eliminar al material ${material.nombre}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar",
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await eliminarMaterial(material.idMaterial);
                }
              });
            }
          }
        };
      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(materialesActivos.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${materialesActivos.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.5" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.5" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "Color tubo/material para toma de muestra",
      width: "55rem",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
      <div style="display:flex; gap:10px; align-items:flex-end; margin-bottom:15px; flex-wrap:wrap;">
        <div style="flex:1; min-width:180px;">
          <label for="swal-nombreMat" style="font-weight:600; font-size:12px; color:#475569; display:block; margin-bottom:4px; text-align:left;">Nombre:</label>
          <input id="swal-nombreMat" style="width:100%; box-sizing:border-box; padding:7px 10px; border:1px solid #cbd5e1; border-radius:6px; font-size:13px; outline:none;" placeholder="Nombre del recipiente / material..." />
        </div>
        <button id="btnAgregarMat" style="background:linear-gradient(135deg, #0f4b75 0%, #006787 100%); color:white; border:none; border-radius:6px; padding:8px 16px; font-weight:600; font-size:13px; cursor:pointer; display:inline-flex; align-items:center; gap:6px; height:34px; box-shadow:0 2px 4px rgba(0,0,0,0.15);">
          <i class="fas fa-plus"></i> Agregar
        </button>
      </div>

      <div style="border:1px solid #cbd5e1; border-radius:8px; overflow:hidden; box-shadow:0 4px 6px -1px rgba(0,0,0,0.08); background:white;">
        <table class="tablaMateriales" style="width:100%; border-collapse:collapse; text-align:center;">
          <thead>
            <tr style="background:linear-gradient(180deg, #0f4b75 0%, #006787 100%); color:white; font-size:13px;">
              <th style="padding:10px 14px; text-align:left; font-weight:600;">Recipiente</th>
              <th style="padding:10px 14px; text-align:left; font-weight:600;">Asociación</th>
              <th style="padding:10px 4px; font-weight:600; width:60px;">Editar</th>
              <th style="padding:10px 4px; font-weight:600; width:60px;">Eliminar</th>
            </tr>
          </thead>
          <tbody id="tablaMateriales">
            
          </tbody>
        </table>
      </div>

      <div style="margin-top:14px; display:flex; justify-content:space-between; align-items:center;">
        <span id="paginaActual" style="font-weight:600; font-size:13px; color:#475569;"></span>
        <div style="display:flex; gap:8px;">
          <button id="btnAnterior" style="background:#006787; color:white; border:none; border-radius:6px; padding:6px 14px; font-weight:600; font-size:12px; cursor:pointer; display:inline-flex; align-items:center; gap:4px; box-shadow:0 1px 2px rgba(0,0,0,0.1);">
            <i class="fas fa-chevron-left" style="font-size:10px;"></i> Anterior
          </button>
          <button id="btnSiguiente" style="background:#006787; color:white; border:none; border-radius:6px; padding:6px 14px; font-weight:600; font-size:12px; cursor:pointer; display:inline-flex; align-items:center; gap:4px; box-shadow:0 1px 2px rgba(0,0,0,0.1);">
            Siguiente <i class="fas fa-chevron-right" style="font-size:10px;"></i>
          </button>
        </div>
      </div>
    `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });

        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (
              paginaActual < Math.ceil(materialesActivos.length / porPagina)
            ) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnAgregarMat")
          .addEventListener("click", async () => {
            try {
              let material = {
                nombre: document.getElementById("swal-nombreMat").value,
                asociacion: "",
                estatus: "A",
              };
              let resultado = await MaterialesService.agregarMaterial(material);
              resultado = await MaterialesService.getMateriales();
              setMateriales(resultado.data.materiales);
              materialesOriginal = resultado.data.materiales;
              materialesActivos = [...materialesOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
              document.getElementById("swal-nombreMat").value = "";
            } catch (error) {
              console.error("Error al recargar materiales:", error);
            }
          });
      },
    });
  }

  const eliminarMaterial = async (matId) => {
    try {
      const resultado = await MaterialesService.deleteMaterial(matId);
      if (resultado.data.estatus === "OK") {
        mostrarMensaje("Material eliminado con éxito!");
        getMateriales();
      } else {
        mostrarError("Error al eliminar material");
      }
    } catch (error) {
      console.error("Error al eliminar material:", error);
      mostrarError("Error al eliminar material");
    }
  };
  const [estudioSubId, setEstudioSubId] = useState(null);

  const [area, setArea] = useState("seleccione");
  const [estudioSub, setEstudioSub] = useState("no");
  const [labRef, setLabRef] = useState("seleccione");
  const [etiquetas, setEtiquetas] = useState([
    {
      numEtiquetas: "",
      abreviatura: "",
      tipoMuestra: "",
      idMaterial: "",
      cantidad: "",
      um: "",
      asociacion: "no",
      indicacionesToma: "",
      indicacionesEstabilidad: "",
    },
  ]);
  const [asociacion, setAsociacion] = useState("");
  const [selectedEstudioId, setSelectedEstudioId] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [viewOnly, setViewOnly] = useState(false);
  const [parametros, setParametros] = useState([]);
  const [codigoEstudioInt, setCodigoEstudioInt] = useState("");
  const [nombre, setNombre] = useState("");
  const [metodo, setMetodo] = useState("");
  const [costoIntPrueba, setCostoIntPrueba] = useState("");
  const [tiempoEntrega, setTiempoEntrega] = useState("");
  const [tiempoProceso, setTiempoProceso] = useState(null);
  const [tiempoProcesoDH, setTiempoProcesoDH] = useState("seleccione");
  const [diasProceso, setDiasProceso] = useState("");
  const [codigoEstudioSub, setCodigoEstudioSub] = useState("");
  const [costoSub, setCostoSub] = useState("");
  const [tiempoEntregaSub, setTiempoEntregaSub] = useState("");
  const [tiempoEntregaSubDH, setTiempoEntregaSubDH] = useState("seleccione");
  const [observacionesEstudio, setObservacionesEstudio] = useState("");
  const [descripcionEstudio, setDescripcionEstudio] = useState("");
  const [registroExamenSub, setRegistroExamenSub] = useState("no");
  const [nombres, setNombres] = useState([]);
  const [materiales, setMateriales] = useState([]);
  const [selectedNombre, setSelectedNombre] = useState(null);
  const [selectedCodigo, setSelectedCodigo] = useState(null);
  const [selectedIdEstudio, setSelectedIdEstudio] = useState("");
  const [estudioIntegra, setEstudioIntegra] = useState("");
  const [condicionesPx, setCondicionesPx] = useState("");
  const [laboratorios, setLaboratorios] = useState([]);
  const [errorNombre, setErrorNombre] = useState(false);
  const [errorArea, setErrorArea] = useState(false);
  const [errorCodigoEstudioInt, setErrorCodigoEstudioInt] = useState(false);
  const [errorTiempoEntrega, setErrorTiempoEntrega] = useState(false);
  const siNoToBool = (valor) => valor === "si";
  const boolToSiNo = (valor) => (valor === true ? "si" : "no");

  const onAreaChange = useValidatedInputChange(setArea, setErrorArea);
  const onEstudioSubChange = useInputChange(setEstudioSub);
  const onLabRefChange = useInputChange(setLabRef);
  const onCodigoEstudioIntChange = useValidatedInputChange(
    setCodigoEstudioInt,
    setErrorCodigoEstudioInt,
  );
  const onNombreChange = useValidatedInputChange(setNombre, setErrorNombre);
  const onMetodoChange = useInputChange(setMetodo);
  const onCostoIntPruebaChange = useInputChange(setCostoIntPrueba);
  const onTiempoEntregaChange = useValidatedInputChange(
    setTiempoEntrega,
    setErrorTiempoEntrega,
  );
  const onTiempoProcesoChange = useInputChange(setTiempoProceso);
  const onTiempoProcesoDHChange = useInputChange(setTiempoProcesoDH);
  const onDiasProcesoChange = useInputChange(setDiasProceso);
  const onCodigoEstudioSubChange = useInputChange(setCodigoEstudioSub);
  const onCostoSubChange = useInputChange(setCostoSub);
  const onTiempoEntregaSubChange = useInputChange(setTiempoEntregaSub);
  const onTiempoEntregaSubDHChange = useInputChange(setTiempoEntregaSubDH);
  const onRegistroExamenSubChange = useInputChange(setRegistroExamenSub);
  const onEstudioIntegraChange = useInputChange(setEstudioIntegra);
  const onCondicionesPxChange = useInputChange(setCondicionesPx);

  const [open, setOpen] = useState(false);
  const estudio = {
    nombre: nombre,
    codigo: codigoEstudioInt,
  };
  // Handlers para ReactQuill y componentes que reciben contenido directo
  const onObservacionesEstudioChange = useDirectChange(setObservacionesEstudio);
  const onDescripcionEstudioChange = useDirectChange(setDescripcionEstudio);
  const onCondicionesPxChangeRichText = useDirectChange(setCondicionesPx);

  // Lista de estudios integrados (nombre visible, id almacenado)
  const [estudiosLista, setEstudiosLista] = useState([]);
  // id seleccionado en la lista para eliminar
  const [selectedListaId, setSelectedListaId] = useState(null);

  const getEstudioId = (est) => est.idEstudio || est.idEstudioSec;

  const agregarEstudioALaLista = async (opcion) => {
    if (!opcion || !opcion.idEstudio) return;

    const idNuevo = String(opcion.idEstudio);
    const idActual = selectedEstudioId ? String(selectedEstudioId) : null;

    try {
      // 1. Evitar agregar el mismo estudio que se está editando
      if (idActual && idNuevo === idActual) {
        mostrarError("No se puede agregar el mismo estudio que se está editando.");
        return;
      }

      // 2. Evitar agregar un estudio que ya está directamente en la lista
      const yaExisteEnLista = estudiosLista.some(
        (e) => String(getEstudioId(e)) === idNuevo
      );
      if (yaExisteEnLista) {
        mostrarError("El estudio ya está incluido en la lista de estudios integrados.");
        return;
      }

      // Helper para extraer ID de sub-estudios
      const getSubId = (s) => String(s.idEstudioSec ?? s.idEstudio ?? s.idEstudioPrin ?? "");

      // 3. Obtener sub-estudios del estudio que se quiere agregar
      const subEstudiosDelNuevo = (await EstudiosIntService.getEstudiosPorEstudio(idNuevo)) || [];
      const subEstudiosNuevoIds = new Set(
        (subEstudiosDelNuevo || []).map((s) => getSubId(s)).filter(Boolean)
      );

      // 3a. Referencia circular: Si el estudio que se agrega ya contiene al estudio actual en edición
      if (idActual && subEstudiosNuevoIds.has(idActual)) {
        mostrarError(
          "No se puede agregar este estudio porque ya contiene al estudio actual como estudio integrado (referencia circular)."
        );
        return;
      }

      // 3b. Si alguno de los sub-estudios del estudio que se agrega ya está en la lista actual
      const coincidenciaDirectaEnLista = estudiosLista.find((e) =>
        subEstudiosNuevoIds.has(String(getEstudioId(e)))
      );
      if (coincidenciaDirectaEnLista) {
        mostrarError(
          `No se puede agregar este estudio porque su estudio integrado "${coincidenciaDirectaEnLista.nombre || 'seleccionado'}" ya está en la lista.`
        );
        return;
      }

      // 4. Verificar contra cada estudio que ya está en la lista actual
      for (const item of estudiosLista) {
        const itemEstId = String(getEstudioId(item));
        if (!itemEstId) continue;

        const subEstudiosExistente = (await EstudiosIntService.getEstudiosPorEstudio(itemEstId)) || [];
        const subEstudiosExistenteIds = new Set(
          (subEstudiosExistente || []).map((s) => getSubId(s)).filter(Boolean)
        );

        // 4a. El estudio a agregar ya es un sub-estudio de alguno ya presente en la lista
        if (subEstudiosExistenteIds.has(idNuevo)) {
          mostrarError(
            `No se puede agregar este estudio porque ya forma parte del estudio integrado "${item.nombre || 'existente'}" que ya está en la lista.`
          );
          return;
        }

        // 4b. Comparten algún sub-estudio entre sí
        const idCompartido = [...subEstudiosNuevoIds].find((subId) =>
          subEstudiosExistenteIds.has(subId)
        );
        if (idCompartido) {
          mostrarError(
            `No se puede agregar este estudio porque uno de sus estudios integrados ya forma parte del estudio "${item.nombre || 'existente'}" en la lista.`
          );
          return;
        }
      }

      // Si pasa todas las validaciones, agregar a la lista
      setEstudiosLista([
        ...estudiosLista,
        {
          idEstudio: opcion.idEstudio,
          idEstudioSec: opcion.idEstudio,
          nombre: opcion.nombre,
          codigo: opcion.codigo,
        },
      ]);
    } catch (err) {
      console.error("Error al validar estudio integrado:", err);
      mostrarError("Ocurrió un error al validar la relación de estudios integrados.");
    } finally {
      setSelectedCodigo(null);
      setSelectedNombre(null);
      setSelectedIdEstudio(null);
      setEstudioIntegra("");
    }
  };

  const eliminarEstudioSeleccionado = (id) => {
    const idToRemove = id || selectedListaId;
    if (!idToRemove) return;
    setEstudiosLista(
      estudiosLista.filter((e) => getEstudioId(e) !== idToRemove),
    );
    if (!id) setSelectedListaId(null);
  };

  const moverEstudioArriba = () => {
    if (selectedListaId === null) return;
    const idx = estudiosLista.findIndex((e) => getEstudioId(e) === selectedListaId);
    if (idx <= 0) return;
    const nuevaLista = [...estudiosLista];
    [nuevaLista[idx - 1], nuevaLista[idx]] = [nuevaLista[idx], nuevaLista[idx - 1]];
    setEstudiosLista(nuevaLista);
  };

  const moverEstudioAbajo = () => {
    if (selectedListaId === null) return;
    const idx = estudiosLista.findIndex((e) => getEstudioId(e) === selectedListaId);
    if (idx < 0 || idx >= estudiosLista.length - 1) return;
    const nuevaLista = [...estudiosLista];
    [nuevaLista[idx], nuevaLista[idx + 1]] = [nuevaLista[idx + 1], nuevaLista[idx]];
    setEstudiosLista(nuevaLista);
  };

  const moverParametroArriba = (index) => {
    if (index <= 0) return;
    setParametros((prev) => {
      const nuevaLista = [...prev];
      [nuevaLista[index - 1], nuevaLista[index]] = [
        nuevaLista[index],
        nuevaLista[index - 1],
      ];
      return nuevaLista;
    });
  };

  const moverParametroAbajo = (index) => {
    setParametros((prev) => {
      if (index < 0 || index >= prev.length - 1) return prev;
      const nuevaLista = [...prev];
      [nuevaLista[index], nuevaLista[index + 1]] = [
        nuevaLista[index + 1],
        nuevaLista[index],
      ];
      return nuevaLista;
    });
  };

  const addParametro = useCallback(() => {
    setParametros((prev) => [
      ...prev,
      {
        parametro: "",
        unidadMedida: "",
        fc: "",
        ui: "",
        tipoReferencia: "",
        valorReferencia: "",
        textoExtra: "",
        intervalosBR: [],
      },
    ]);
  }, []);
  const addEtiqueta = useCallback(() => {
    setEtiquetas((prev) => [
      ...prev,
      {
        numEtiquetas: "",
        abreviatura: "",
        tipoMuestra: "",
        idMaterial: "",
        cantidad: "",
        um: "",
        asociacion: "no",
        indicacionesToma: "",
        indicacionesEstabilidad: "",
      },
    ]);
  }, []);

  const handleRemoveEtiqueta = useCallback((index) => {
    setEtiquetas((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const handleRemoveParametro = useCallback((index) => {
    setParametros((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const removeIntervaloBR = useCallback((paramIndex, intervaloIndex) => {
    setParametros((prev) => {
      const nuevos = [...prev];
      const param = { ...nuevos[paramIndex] };
      const intervalos = param.intervalosBR ? [...param.intervalosBR] : [];
      intervalos.splice(intervaloIndex, 1);
      param.intervalosBR = intervalos;
      nuevos[paramIndex] = param;
      return nuevos;
    });
  }, []);

  const addIntervaloBR = useCallback((paramIndex) => {
    setParametros((prev) => {
      const nuevos = [...prev];
      const param = { ...nuevos[paramIndex] };
      const intervalos = param.intervalosBR ? [...param.intervalosBR] : [];
      intervalos.push({
        intervaloMin: "",
        intervaloMax: "",
        genero: "ambos",
        edadMin: "",
        edadMax: "",
        tipoEdad: "Años",
        nivelD1: "",
        nivelD2: "",
        nivelD3: "",
        nivelD4: "",
        nivelD5: "",
        valorCMin: "",
        valorCMax: "",
      });
      param.intervalosBR = intervalos;
      nuevos[paramIndex] = param;
      return nuevos;
    });
  }, []);

  const handleTipoValorChange = useCallback((index, value) => {
    setParametros((prev) => {
      const nuevos = [...prev];
      const parametro = { ...nuevos[index], tipoReferencia: value };
      if (
        value === "intervaloBR" &&
        (!parametro.intervalosBR || parametro.intervalosBR.length === 0)
      ) {
        parametro.intervalosBR = [
          {
            intervaloMin: "",
            intervaloMax: "",
            genero: "ambos",
            edadMin: "",
            edadMax: "",
            tipoEdad: "Años",
            nivelD1: "",
            nivelD2: "",
            nivelD3: "",
            nivelD4: "",
            nivelD5: "",
            valorCMin: "",
            valorCMax: "",
          },
        ];
      }
      if (value === "mixto") {
        if (!parametro.valoresPosibles) {
          parametro.valoresPosibles = [];
        }
        if (!parametro.valorPredeterminado) {
          parametro.valorPredeterminado = "";
        }
        if (!parametro.nuevoValorInput) {
          parametro.nuevoValorInput = "";
        }
        if (!parametro.valorSeleccionadoList) {
          parametro.valorSeleccionadoList = "";
        }
      }
      nuevos[index] = parametro;
      return nuevos;
    });
  }, []);

  const handleChangeIntervaloBR = useCallback(
    (paramIndex, intervaloIndex, field, value) => {
      setParametros((prev) => {
        const nuevos = [...prev];
        const param = { ...nuevos[paramIndex] };
        const intervalos = param.intervalosBR ? [...param.intervalosBR] : [];
        const intervalo = { ...intervalos[intervaloIndex] };
        intervalo[field] = value;
        intervalos[intervaloIndex] = intervalo;
        param.intervalosBR = intervalos;
        nuevos[paramIndex] = param;
        return nuevos;
      });
    },
    [],
  );

  const handleChangeParametro = useCallback((index, field, value) => {
    setParametros((prev) => {
      const nuevosParametros = [...prev];
      nuevosParametros[index] = {
        ...nuevosParametros[index],
        [field]: value,
      };
      return nuevosParametros;
    });
  }, []);

  const addValorALista = useCallback((index) => {
    setParametros((prev) => {
      const nuevos = [...prev];
      const param = { ...nuevos[index] };
      const val = (param.nuevoValorInput || "").trim();
      if (!val) return prev;
      const currentList = param.valoresPosibles || [];
      if (currentList.includes(val)) {
        mostrarError("El valor ya existe en la lista.");
        return prev;
      }
      param.valoresPosibles = [...currentList, val];
      param.nuevoValorInput = "";
      nuevos[index] = param;
      return nuevos;
    });
  }, [mostrarError]);

  const removeValorDeLista = useCallback((index) => {
    setParametros((prev) => {
      const nuevos = [...prev];
      const param = { ...nuevos[index] };
      const valSelected = param.valorSeleccionadoList;
      if (!valSelected) return prev;
      const currentList = param.valoresPosibles || [];
      param.valoresPosibles = currentList.filter((v) => v !== valSelected);
      param.valorSeleccionadoList = "";
      if (param.valorPredeterminado === valSelected) {
        param.valorPredeterminado = "";
      }
      nuevos[index] = param;
      return nuevos;
    });
  }, []);

  const handleSelectValorDeLista = useCallback((index, value) => {
    setParametros((prev) => {
      const nuevos = [...prev];
      const param = { ...nuevos[index] };
      param.valorSeleccionadoList = value;
      param.valorPredeterminado = value;
      nuevos[index] = param;
      return nuevos;
    });
  }, []);

  const clearValorPredeterminado = useCallback((index) => {
    setParametros((prev) => {
      const nuevos = [...prev];
      const param = { ...nuevos[index] };
      param.valorPredeterminado = "";
      nuevos[index] = param;
      return nuevos;
    });
  }, []);

  const clearValorReferencia = useCallback((index) => {
    setParametros((prev) => {
      const nuevos = [...prev];
      const param = { ...nuevos[index] };
      param.valorReferencia = "";
      nuevos[index] = param;
      return nuevos;
    });
  }, []);

  const handleChangeEtiqueta = useCallback((index, field, value) => {
    setEtiquetas((prev) => {
      const nuevasEtiquetas = [...prev];
      nuevasEtiquetas[index] = {
        ...nuevasEtiquetas[index],
        [field]: value,
      };
      return nuevasEtiquetas;
    });
  }, []);

  async function getAreas() {
    const resultado = await AreasService.getAreas();
    setAreas(resultado.data.areas);
  }
  async function getEstudios() {
    const resultado = await EstudiosService.getEstudios();
    setNombres(resultado.data.estudios);
  }

  async function getMateriales() {
    const resultado = await MaterialesService.getMateriales();
    setMateriales(resultado.data.materiales);
  }

  async function getLaboratorios() {
    const resultado = await LaboratoriosService.getLaboratorios();
    setLaboratorios(resultado.data.laboratorios);
  }

  const agregarEstudio = async () => {
    let areaN = area === "" || area === "seleccione" ? null : area;
    let laboratorioN = labRef === "" || labRef === "seleccione" ? null : labRef;
    let tiempoProcesoDHN =
      tiempoProcesoDH === "seleccione" ? "" : tiempoProcesoDH;
    let tiempoEntregaSubDHN =
      tiempoEntregaSubDH === "seleccione" ? "" : tiempoEntregaSubDH;
    if (
      area === "" &&
      codigoEstudioInt === "" &&
      nombre === "" &&
      tiempoEntrega === ""
    ) {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorArea(true);
      setErrorCodigoEstudioInt(true);
      setErrorNombre(true);
      setErrorTiempoEntrega(true);
    } else if (areaN === "" || areaN === null) {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorArea(true);
    } else if (codigoEstudioInt === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorCodigoEstudioInt(true);
    } else if (nombre === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorNombre(true);
    } else if (tiempoEntrega === "") {
      mostrarError("Rellene los cambios obligatorios!");
      setErrorTiempoEntrega(true);
    } else {
      const muestrasSanetizadas = (etiquetas || []).map((e) => ({
        ...e,
        numEtiquetas:
          e.numEtiquetas !== "" && e.numEtiquetas !== null && e.numEtiquetas !== undefined
            ? parseInt(e.numEtiquetas, 10)
            : null,
        idMaterial: e.idMaterial ? parseInt(e.idMaterial, 10) : null,
      }));

      let estudio = {
        estudio: {
          codigo: codigoEstudioInt,
          nombre: nombre,
          metodo: metodo,
          costoIntPrueba: costoIntPrueba,
          tiempoEntrega: tiempoEntrega,
          tiempoProceso: tiempoProceso,
          tiempoProcesoDH: tiempoProcesoDHN,
          diasProceso: diasProceso,
          esSubrogado: siNoToBool(estudioSub),
          observaciones: observacionesEstudio,
          descripcionCien: descripcionEstudio,
          estatus: "A",
          condicionesPaciente: condicionesPx,
          idArea: areaN,
          registroExamenSub: siNoToBool(registroExamenSub),
        },
        estudioSub: {
          idLaboratorio: laboratorioN,
          codigo: codigoEstudioSub,
          costo: costoSub,
          tiempoEntrega: tiempoEntregaSub,
          tiempoEntregaDH: tiempoEntregaSubDHN,
        },
        parametrosEstudio: serializarParametrosParaBackend(parametros),
        estudiosInt: estudiosLista,
        sinonimos: sinonimos,
        muestras: muestrasSanetizadas,
      };

      let estudioUpd = {
        estudioN: {
          codigoN: codigoEstudioInt,
          nombreN: nombre,
          metodoN: metodo,
          costoIntPruebaN: costoIntPrueba,
          tiempoEntregaN: tiempoEntrega,
          tiempoProcesoN: tiempoProceso,
          tiempoProcesoDHN: tiempoProcesoDHN,
          diasProcesoN: diasProceso,
          esSubrogadoN: siNoToBool(estudioSub),
          observacionesN: observacionesEstudio,
          descripcionCienN: descripcionEstudio,
          estatusN: "A",
          condicionesPacienteN: condicionesPx,
          idAreaN: areaN,
          idEstudioSubN: estudioSubId,
          registroExamenSubN: siNoToBool(registroExamenSub),
        },
        estudioSubN: {
          idEstudioSubN: estudioSubId,
          idLaboratorioN: laboratorioN,
          codigoN: codigoEstudioSub,
          costoN: costoSub,
          tiempoEntregaN: tiempoEntregaSub,
          tiempoEntregaDHN: tiempoEntregaSubDHN,
        },
        parametrosEstudioN: serializarParametrosParaBackend(parametros),
        estudiosIntN: estudiosLista,
        sinonimosN: sinonimos,
        muestrasN: muestrasSanetizadas,
      };
      try {
        let resultado;
        if (editMode) {
          resultado = await EstudiosService.updateEstudio(
            estudioUpd,
            selectedEstudioId,
          );
          if (resultado.data.estatus === "OK") {
            mostrarMensaje("Estudio modificado con éxito!");
            getEstudios();
          } else {
            mostrarError(
              "No se pudo modificar el estudio: " + resultado.data.mensaje,
            );
          }
        } else {
          resultado = await EstudiosService.agregarEstudio(estudio);
          if (resultado.data.estatus === "OK") {
            const idCreado = resultado.data.idEstudio;
            if (idCreado) {
              await editarEstudio({ idEstudio: idCreado });
            } else {
              setEditMode(true);
            }
            mostrarMensaje("Estudio agregado con éxito!");
            getEstudios();
          } else {
            mostrarError(
              "No se pudo agregar el estudio: " + resultado.data.mensaje,
            );
          }
        }
      } catch (error) {
        mostrarError("Error al actualizar estudio:", error);
      }
    }
  };
  const verEstudio = async (estudio) => {
    let estudioCompleto;
    let estudioSubVer;
    try {
      let resultado;
      estudioCompleto = await EstudiosService.getEstudioPorId(
        estudio.idEstudio,
      );
      setSelectedEstudioId(estudioCompleto.idEstudio);
      if (estudioCompleto.idEstudioSub !== null) {
        resultado = await EstudiosSubService.getEstudioSubPorId(
          estudioCompleto.idEstudioSub,
        );
        estudioSubVer = resultado;
      }
      resultado = await ParametrosEstudioService.getParametrosPorEstudio(
        estudio.idEstudio,
      );
      setParametros(deserializarParametrosParaBackend(resultado));
      resultado = await EstudiosIntService.getEstudiosPorEstudio(
        estudio.idEstudio,
      );
      const estudiosConNombre = (resultado || []).map((e) => {
        const idSec = e.idEstudioSec || e.idEstudio;
        const estObj = nombres.find((est) => String(est.idEstudio) === String(idSec));
        return {
          idEstudiosInt: e.idEstudiosInt,
          idEstudioPrin: e.idEstudioPrin,
          idEstudioSec: idSec,
          idEstudio: idSec,
          nombre: estObj ? estObj.nombre : (e.nombre || "Sin nombre"),
          codigo: estObj ? estObj.codigo : (e.codigo || ""),
        };
      });

      setEstudiosLista(estudiosConNombre);
      resultado = await SinonimosService.getSinonimosPorEstudio(
        estudio.idEstudio,
      );
      setSinonimos(Array.isArray(resultado) ? resultado : []);
      resultado = await MuestrasService.getMuestrasPorEstudio(
        estudio.idEstudio,
      );
      const etiquetasTransformadas = resultado.map((etiqueta) => {
        return {
          ...etiqueta,
          asociacion: etiqueta.asociacion ? "si" : "no",
        };
      });

      setEtiquetas(
        etiquetasTransformadas.length > 0
          ? etiquetasTransformadas
          : [
            {
              numEtiquetas: "",
              abreviatura: "",
              tipoMuestra: "",
              idMaterial: "",
              cantidad: "",
              um: "",
              asociacion: "no",
              indicacionesToma: "",
              indicacionesEstabilidad: "",
            },
          ]
      );
    } catch (error) {
      console.error(error);
    }
    setArea(estudioCompleto.idArea || "");
    setCodigoEstudioInt(estudioCompleto.codigo || "");
    setNombre(estudioCompleto.nombre || "");
    setMetodo(estudioCompleto.metodo || "");
    setCostoIntPrueba(estudioCompleto.costoIntPrueba || "");
    setTiempoEntrega(estudioCompleto.tiempoEntrega || "");
    setTiempoProceso(estudioCompleto.tiempoProceso || null);
    setTiempoProcesoDH(estudioCompleto.tiempoProcesoDH || "");
    setDiasProceso(estudioCompleto.diasProceso || "");
    if (estudioCompleto.esSubrogado) {
      setEstudioSub("si");
    } else {
      setEstudioSub("no");
    }
    setObservacionesEstudio(estudioCompleto.observaciones || "");
    setDescripcionEstudio(estudioCompleto.descripcionCien || "");
    setCondicionesPx(estudioCompleto.condicionesPaciente || "");
    setEstudioSubId(estudioCompleto.idEstudioSub || null);
    setLabRef(estudioSubVer?.idLaboratorio || null);
    setCodigoEstudioSub(estudioSubVer?.codigo || "");
    setCostoSub(estudioSubVer?.costo || "");
    setTiempoEntregaSub(estudioSubVer?.tiempoEntrega || "");
    setTiempoEntregaSubDH(estudioSubVer?.tiempoEntregaDH || "");
    setRegistroExamenSub(boolToSiNo(estudioCompleto.registroExamenSub));
    setEditMode(false);
    setViewOnly(true);
  };

  const editarEstudio = async (estudio) => {
    let estudioCompleto;
    let estudioSubVer;
    try {
      let resultado;
      estudioCompleto = await EstudiosService.getEstudioPorId(
        estudio.idEstudio,
      );

      resultado = await EstudiosSubService.getEstudioSubPorId(
        estudioCompleto.idEstudioSub,
      );
      estudioSubVer = resultado;
      resultado = await ParametrosEstudioService.getParametrosPorEstudio(
        estudio.idEstudio,
      );
      setParametros(deserializarParametrosParaBackend(resultado));
      resultado = await EstudiosIntService.getEstudiosPorEstudio(
        estudio.idEstudio,
      );
      const estudiosConNombre = (resultado || []).map((e) => {
        const idSec = e.idEstudioSec || e.idEstudio;
        const estObj = nombres.find((est) => String(est.idEstudio) === String(idSec));
        return {
          idEstudiosInt: e.idEstudiosInt,
          idEstudioPrin: e.idEstudioPrin,
          idEstudioSec: idSec,
          idEstudio: idSec,
          nombre: estObj ? estObj.nombre : (e.nombre || "Sin nombre"),
          codigo: estObj ? estObj.codigo : (e.codigo || ""),
        };
      });

      setEstudiosLista(estudiosConNombre);
      resultado = await SinonimosService.getSinonimosPorEstudio(
        estudio.idEstudio,
      );
      setSinonimos(Array.isArray(resultado) ? resultado : []);
      resultado = await MuestrasService.getMuestrasPorEstudio(
        estudio.idEstudio,
      );
      const etiquetasTransformadas = resultado.map((etiqueta) => {
        return {
          ...etiqueta,
          asociacion: etiqueta.asociacion ? "si" : "no",
        };
      });
      setEtiquetas(
        etiquetasTransformadas.length > 0
          ? etiquetasTransformadas
          : [
            {
              numEtiquetas: "",
              abreviatura: "",
              tipoMuestra: "",
              idMaterial: "",
              cantidad: "",
              um: "",
              asociacion: "no",
              indicacionesToma: "",
              indicacionesEstabilidad: "",
            },
          ]
      );
    } catch (error) {
      console.error(error);
    }

    setSelectedEstudioId(estudioCompleto.idEstudio);
    setArea(estudioCompleto.idArea || "");
    setCodigoEstudioInt(estudioCompleto.codigo || "");
    setNombre(estudioCompleto.nombre || "");
    setMetodo(estudioCompleto.metodo || "");
    setCostoIntPrueba(estudioCompleto.costoIntPrueba || "");
    setTiempoEntrega(estudioCompleto.tiempoEntrega);
    setTiempoProceso(estudioCompleto.tiempoProceso || null);
    setTiempoProcesoDH(estudioCompleto.tiempoProcesoDH || "");
    setDiasProceso(estudioCompleto.diasProceso || "");
    if (estudioCompleto.esSubrogado) {
      setEstudioSub("si");
    } else {
      setEstudioSub("no");
    }
    setObservacionesEstudio(estudioCompleto.observaciones || "");
    setDescripcionEstudio(estudioCompleto.descripcionCien || "");
    setCondicionesPx(estudioCompleto.condicionesPaciente || "");
    setEstudioSubId(estudioCompleto.idEstudioSub || null);
    setLabRef(estudioSubVer?.idLaboratorio || null);
    setCodigoEstudioSub(estudioSubVer?.codigo || "");
    setCostoSub(estudioSubVer?.costo || "");
    setTiempoEntregaSub(estudioSubVer?.tiempoEntrega || "");
    setTiempoEntregaSubDH(estudioSubVer?.tiempoEntregaDH || "");
    setRegistroExamenSub(boolToSiNo(estudioCompleto.registroExamenSub));
    setEditMode(true);
    setViewOnly(false);
  };

  const eliminarEstudio = async (estudioId) => {
    try {
      const resultado = await EstudiosService.deleteEstudio(estudioId);
      if (resultado.data.estatus === "OK") {
        mostrarMensaje("Estudio eliminado con éxito!");
        getEstudios();
      } else {
        mostrarError("Error al eliminar estudio");
      }
    } catch (error) {
      console.error("Error al eliminar estudio:", error);
      mostrarError("Error al eliminar estudio");
    }
  };

  async function mostrarBuscarEstudio() {
    let estudiosOriginal = [];
    let estudiosActivos = [];

    const ordenarEstudiosAlfabetico = (lista) => {
      if (!Array.isArray(lista)) return [];
      return [...lista].sort((a, b) => {
        const nomA = String(a.nombre || a.nombreEstudio || "").trim();
        const nomB = String(b.nombre || b.nombreEstudio || "").trim();
        return nomA.localeCompare(nomB, undefined, { sensitivity: "base", numeric: true });
      });
    };

    const resultado = await EstudiosService.getEstudios();
    estudiosOriginal = ordenarEstudiosAlfabetico(resultado?.data?.estudios || resultado?.estudios || []);
    estudiosActivos = [...estudiosOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (lista) => {
      return lista
        .map(
          (est, idx) => `
        <tr style="background-color: ${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom: 1px solid #e2e8f0; font-size: 0.80rem; transition: background 0.15s;">
          <td style="padding: 6px 12px; text-align: left; font-weight: 500; color: #1e293b; border-right: 1px solid #f1f5f9;">${est.nombre}</td>
          <td style="padding: 6px 10px; text-align: center; font-weight: 600; color: #1e293b; border-right: 1px solid #f1f5f9;">${est.codigo}</td>
          <td style="padding: 6px 10px; text-align: left; color: #64748b; font-size: 0.78rem; border-right: 1px solid #f1f5f9;">(${est.sinonimos || ""})</td>
          <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
            <button data-action="mostrar" data-idestudio="${est.idEstudio}" title="Mostrar" style="background: #e0f2fe; color: #0284c7; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
              <i class="fas fa-eye"></i>
            </button>
          </td>
          <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
            <button data-action="editar" data-idestudio="${est.idEstudio}" title="Editar" style="background: #fef3c7; color: #d97706; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
              <i class="fas fa-edit"></i>
            </button>
          </td>
          <td style="padding: 4px 6px; text-align: center;">
            <button data-action="eliminar" data-idestudio="${est.idEstudio}" title="Eliminar" style="background: #fee2e2; color: #dc2626; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
      `,
        )
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginaEstudios = estudiosActivos.slice(inicio, fin);
      const tabla = document.getElementById("tablaEstudios");
      if (tabla) {
        if (!paginaEstudios || paginaEstudios.length === 0) {
          tabla.innerHTML = `<tr><td colspan="6" style="padding: 24px; text-align: center; color: #64748b; font-style: italic;">No hay registros</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginaEstudios);
        }
        tabla
          .querySelectorAll("button[data-action='mostrar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idestudio;
              const estudio = estudiosOriginal.find(
                (item) => String(item.idEstudio) === String(id),
              );
              if (estudio) {
                verEstudio(estudio);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='editar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idestudio;
              const estudio = estudiosOriginal.find(
                (item) => String(item.idEstudio) === String(id),
              );
              if (estudio) {
                editarEstudio(estudio);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='eliminar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idestudio;
              const estudio = estudiosOriginal.find(
                (item) => String(item.idEstudio) === String(id),
              );
              if (estudio) {
                Swal.fire({
                  title: "¿Eliminar estudio?",
                  text: `¿Desea eliminar el estudio ${estudio.nombre}?`,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Sí, eliminar",
                  cancelButtonText: "Cancelar",
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    await eliminarEstudio(estudio.idEstudio);
                  }
                });
              }
            });
          });
      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(estudiosActivos.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${estudiosActivos.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.45" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.45" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "BUSCAR ESTUDIO",
      width: "65%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
        <div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; text-align: left;">
          <div style="display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; flex-wrap: wrap; margin-bottom: 8px;">
            <div style="display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 220px;">
              <label style="font-size: 0.80rem; font-weight: 600; color: #334155;">Nombre o código del estudio:</label>
              <input id="buscarEstudios" type="text" style="padding: 5px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.82rem; outline: none; height: 32px; box-sizing: border-box;" placeholder="Escribe aquí...">
            </div>
            <div>
              <button id="btnMostrarTodos" style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; border: none; border-radius: 6px; font-weight: 600; font-size: 0.80rem; padding: 6px 14px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1); height: 32px; white-space: nowrap; transition: opacity 0.2s;">
                Mostrar todos los estudios
              </button>
            </div>
          </div>
  
          <div style="width: 100%; overflow: auto; max-height: 52vh; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.08); background: white;">
            <table class="tablaEstudios" style="width: 100%; border-collapse: collapse; text-align: center;">
              <thead>
                <tr style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; font-size: 0.80rem; position: sticky; top: 0; z-index: 2;">
                  <th style="padding: 7px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Estudio</th>
                  <th style="padding: 7px 10px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Código</th>
                  <th style="padding: 7px 10px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Sinónimos</th>
                  <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Mostrar</th>
                  <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Editar</th>
                  <th style="padding: 7px 8px; text-align: center; font-weight: 600; width: 45px;">Eliminar</th>
                </tr>
              </thead>
              <tbody id="tablaEstudios">
              </tbody>
            </table>
          </div>

          <div style="margin-top: 8px; display: flex; justify-content: space-between; align-items: center;">
            <span id="paginaActual" style="font-size: 0.80rem; color: #64748b; font-weight: 500;"></span>
            <div style="display: flex; gap: 6px;">
              <button id="btnAnterior" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Anterior</button>
              <button id="btnSiguiente" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Siguiente</button>
            </div>
          </div>
        </div>
      `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });

        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (paginaActual < Math.ceil(estudiosActivos.length / porPagina)) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnMostrarTodos")
          .addEventListener("click", async () => {
            try {
              const resultado = await EstudiosService.getEstudios();
              estudiosOriginal = ordenarEstudiosAlfabetico(resultado?.data?.estudios || resultado?.estudios || []);
              estudiosActivos = [...estudiosOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error al recargar estudios:", error);
            }
            document.getElementById("buscarEstudios").value = "";
          });
        document
          .getElementById("buscarEstudios")
          .addEventListener("input", async (e) => {
            const valor = e.target.value.trim();
            paginaActual = 1;
            if (valor === "") {
              estudiosActivos = [...estudiosOriginal];
              renderPagina(paginaActual);
              return;
            }

            try {
              const resultado = await EstudiosService.buscarEstudios(valor);
              estudiosActivos = ordenarEstudiosAlfabetico(resultado?.estudios || resultado?.data?.estudios || []);
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error en búsqueda:", error);
            }
          });
      },
    });
  }

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Box sx={{ width: "95vw", maxWidth: "96vw", mb: 2 }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                aria-label="tabs doctor"
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab
                  label="Datos del estudio"
                  id="tab-0"
                  aria-controls="tabpanel-0"
                  sx={{
                    color: "black",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "8px",
                    marginRight: "8px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#d9eaf7",
                      color: "#006787",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#006787",
                      color: "white",
                    },
                  }}
                />
                <Tab
                  label="Estudios que lo integran"
                  id="tab-1"
                  aria-controls="tabpanel-1"
                  sx={{
                    color: "black",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "8px",
                    marginRight: "8px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#d9eaf7",
                      color: "#006787",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#014e65",
                      color: "white",
                    },
                  }}
                />
                <Tab
                  label="Sinonimos del estudio"
                  id="tab-2"
                  aria-controls="tabpanel-2"
                  sx={{
                    color: "black",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "8px",
                    marginRight: "8px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#d9eaf7",
                      color: "#006787",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#014e65",
                      color: "white",
                    },
                  }}
                />
                <Tab
                  label="Muestras del estudio"
                  id="tab-3"
                  aria-controls="tabpanel-3"
                  sx={{
                    color: "black",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "8px",
                    marginRight: "8px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#d9eaf7",
                      color: "#006787",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#014e65",
                      color: "white",
                    },
                  }}
                />
              </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0}>
              <Stack spacing={2} sx={{ width: "100%" }}>


                <Paper
                  elevation={3}
                  sx={{ p: 2, borderRadius: 4 }}
                  className="paperLugar"
                >
                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"1vw"}
                    sx={{ paddingTop: "0vw" }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        variant="h7"
                        fontWeight="bold"
                        gutterBottom
                        align="center"
                        sx={{
                          background:
                            "linear-gradient(90deg, #006787, #014e65)",
                          color: "white",
                          padding: "0.5vw 1vw",
                          borderRadius: "8px",
                          display: "inline-block",
                          marginTop: "0vw",
                          fontWeight: "bold"
                        }}
                      >
                        DATOS GENERALES DEL ESTUDIO
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"2vw"}
                    sx={{ paddingTop: "0.4vw" }}
                  >
                    {/* Volvemos a dejar el Stack normal para que las columnas tengan la misma altura */}
                    <Stack
                      direction="row"
                      spacing={"3vw"}
                      sx={{ width: "100%" }}
                    >
                      {/* ÁREA */}
                      <Grid
                        item
                        xs={2}
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          mt="0.3vh"
                        >
                          <InputLabel
                            htmlFor="selectArea"
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                              marginTop: 0,
                              lineHeight: 1,
                            }}
                          >
                            <span style={{ color: "red" }}>*</span>
                            Área:
                          </InputLabel>

                          <IconButton
                            onClick={agregarArea}
                            sx={{
                              color: "#006787",
                              padding: 0,
                              transition:
                                "transform 0.2s ease, color 0.2s ease",
                              "&:hover": {
                                color: "#014e65",
                                transform: "scale(1.5)",
                              },
                            }}
                          >
                            <AddCircleIcon sx={{ fontSize: "1.1vw" }} />
                          </IconButton>
                        </Box>

                        <Select
                          input={<OutlinedInput />}
                          value={area}
                          disabled={viewOnly}
                          onChange={onAreaChange}
                          error={errorArea}
                          helperText={errorArea ? "Area obligatoria" : ""}
                          sx={{
                            width: "12.51vw",
                            maxWidth: "100%",
                            height: "5vh",
                            minHeight: "0px !important",
                            overflow: "hidden",
                            "&.MuiInputBase-root": {
                              minHeight: "0px !important",
                            },
                            "& .MuiSelect-select": {
                              minHeight: "0px !important",
                              padding: "0 0.5vw !important",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "1vw",
                              lineHeight: "1",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              top: 0,
                              "& legend": { display: "none" },
                            },
                            "& .MuiSvgIcon-root": {
                              position: "absolute",
                              right: "0.5vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              fontSize: "1.2vw !important",
                              width: "1.2vw !important",
                              height: "1.2vw !important",
                              pointerEvents: "none",
                            },
                            minWidth: "0px !important",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                          className="selectArea"
                        >
                          <MenuItem
                            sx={{ fontSize: "1vw", padding: "0.5vw" }}
                            value="seleccione"
                            disabled
                          >
                            Seleccione
                          </MenuItem>
                          {areas.map((area) => (
                            <MenuItem
                              key={area.idArea}
                              value={area.idArea}
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                            >
                              {area.nombre || ""}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>

                      {/* FECHA DE NACIMIENTO */}
                      <Grid
                        item
                        xs={2}
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                      >
                        <InputLabel
                          htmlFor="txfCodigo"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                            mb: "0.2vh",
                          }}
                        >
                          <span style={{ color: "red" }}>*</span> Codigo:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={viewOnly}
                          value={codigoEstudioInt}
                          onChange={onCodigoEstudioIntChange}
                          error={errorCodigoEstudioInt}
                          helperText={
                            errorCodigoEstudioInt ? "Codigo obligatorio" : ""
                          }
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "12.51vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfCodigo"
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>

                      {/* EMAIL */}
                      <Grid
                        item
                        xs={6}
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                      >
                        <InputLabel
                          htmlFor="txfNombre"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                            mb: "0.2vh",
                          }}
                        >
                          <span style={{ color: "red" }}>*</span> Nombre:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={viewOnly}
                          value={nombre}
                          onChange={onNombreChange}
                          error={errorNombre}
                          helperText={errorNombre ? "Nombre obligatorio" : ""}
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "24vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfNombre"
                        />
                      </Grid>

                      {/* TELÉFONO (TRABAJO) */}
                      <Grid
                        item
                        xs={6}
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                      >
                        <InputLabel
                          htmlFor="txfMetodo"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                            mb: "0.2vh",
                          }}
                        >
                          Metodo:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={viewOnly}
                          value={metodo}
                          onChange={onMetodoChange}
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "16vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfMetodo"
                        />
                      </Grid>
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"2vw"}
                    sx={{ paddingTop: "0.4vw" }}
                  >
                    {/* Volvemos a dejar el Stack normal para que las columnas tengan la misma altura */}
                    <Stack direction="row" spacing={"3vw"}>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfCostoIntPrueba"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Costo interno por prueba:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={viewOnly}
                          value={costoIntPrueba}
                          onChange={onCostoIntPruebaChange}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "12.51vw",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfCostoIntPrueba"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfTiempoEntrega"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          <span style={{ color: "red" }}>*</span>Tiempo de entrega:
                        </InputLabel>

                        <Stack direction="row" spacing={"0.2vw"}>
                          <TextField
                            fullWidth
                            disabled={viewOnly}
                            value={tiempoEntrega}
                            onChange={onTiempoEntregaChange}
                            error={errorTiempoEntrega}
                            helperText={
                              errorTiempoEntrega
                                ? "Tiempo de entrega obligatoria"
                                : ""
                            }
                            required
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "10vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfTiempoEntrega"
                          />
                          <Typography
                            sx={{ fontSize: "1vw", fontWeight: "bold" }}
                          >
                            Día(s)
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfTiempoProceso"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Tiempo de proceso:
                        </InputLabel>
                        <Stack direction="row" spacing={"0vw"}>
                          <TextField
                            fullWidth
                            disabled={viewOnly}
                            value={tiempoProceso}
                            onChange={onTiempoProcesoChange}
                            required
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "12vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfTiempoProceso"
                          />
                          <Select
                            input={<OutlinedInput />}
                            disabled={viewOnly}
                            value={tiempoProcesoDH}
                            onChange={onTiempoProcesoDHChange}
                            sx={{
                              width: "9vw",
                              maxWidth: "100%",

                              height: "5vh",
                              minHeight: "0px !important",
                              overflow: "hidden",

                              "&.MuiInputBase-root": {
                                minHeight: "0px !important",
                              },

                              "& .MuiSelect-select": {
                                minHeight: "0px !important",
                                padding: "0 0.5vw !important",
                                display: "flex",
                                alignItems: "center",
                                fontSize: "1vw",
                                lineHeight: "1",
                              },

                              "& .MuiOutlinedInput-notchedOutline": {
                                top: 0,
                                "& legend": { display: "none" },
                              },

                              "& .MuiSvgIcon-root": {
                                display: "inline-block !important",
                                position: "absolute",
                                right: "0.5vw",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "1.2vw !important",
                                width: "1.2vw !important",
                                height: "1.2vw !important",
                                pointerEvents: "none",
                              },
                              minWidth: "0px !important",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                            className="selectTiempoProceso"
                          >
                            <MenuItem
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                              value="seleccione"
                              disabled
                            >
                              Seleccione
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                              value="dias"
                            >
                              Dia(s)
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                              value="horas"
                            >
                              Hora(s)
                            </MenuItem>
                          </Select>
                        </Stack>
                      </Grid>
                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="txfDiasProceso"
                          sx={{
                            ml: "3.2vw",
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Dias de proceso:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={viewOnly}
                          value={diasProceso}
                          onChange={onDiasProcesoChange}
                          sx={{
                            "& .MuiInputBase-root": {
                              ml: "3.2vw",
                              width: "16vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfDiasProceso"
                        />
                      </Grid>
                    </Stack>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"2vw"}
                    sx={{ paddingTop: "0.4vw" }}
                  >
                    {/* Volvemos a dejar el Stack normal para que las columnas tengan la misma altura */}
                    <Stack direction="row" spacing={"3.2vw"}>
                      <Grid item xs={6}>
                        <FormControl>
                          <FormLabel
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            ¿Este es un estudio subrogado?:
                          </FormLabel>
                          <RadioGroup
                            row
                            value={estudioSub}
                            onChange={onEstudioSubChange}
                            disabled={viewOnly}
                          >
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontFamily: "Roboto-Regular",
                                },
                              }}
                              value="si"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Sí"
                            />
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontFamily: "Roboto-Regular",
                                },
                              }}
                              value="no"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="No"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      <Grid
                        item
                        xs={2}
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          mt="0.3vh"
                        >
                          <InputLabel
                            htmlFor="selectLabRef"
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                              marginTop: 0,
                              lineHeight: 1,
                              ml: "0.8vw",
                            }}
                          >
                            Laboratorio de referencia:
                          </InputLabel>

                          <IconButton
                            onClick={agregarLaboratorio}
                            sx={{
                              color: "#006787",
                              padding: 0,
                              transition:
                                "transform 0.2s ease, color 0.2s ease",
                              "&:hover": {
                                color: "#014e65",
                                transform: "scale(1.5)",
                              },
                            }}
                          >
                            <AddCircleIcon sx={{ fontSize: "1.1vw" }} />
                          </IconButton>
                        </Box>

                        <Select
                          input={<OutlinedInput />}
                          value={labRef}
                          disabled={viewOnly || estudioSub === "no"}
                          onChange={onLabRefChange}
                          sx={{
                            ml: "0.8vw",
                            width: "12.51vw",
                            maxWidth: "100%",
                            height: "5vh",
                            minHeight: "0px !important",
                            overflow: "hidden",
                            "&.MuiInputBase-root": {
                              minHeight: "0px !important",
                            },
                            "& .MuiSelect-select": {
                              minHeight: "0px !important",
                              padding: "0 0.5vw !important",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "1vw",
                              lineHeight: "1",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              top: 0,
                              "& legend": { display: "none" },
                            },
                            "& .MuiSvgIcon-root": {
                              position: "absolute",
                              right: "0.5vw",
                              top: "50%",
                              transform: "translateY(-50%)",
                              fontSize: "1.2vw !important",
                              width: "1.2vw !important",
                              height: "1.2vw !important",
                              pointerEvents: "none",
                            },
                            minWidth: "0px !important",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                          }}
                          className="selectLabRef"
                        >
                          <MenuItem
                            sx={{ fontSize: "1vw", padding: "0.5vw" }}
                            value="seleccione"
                            disabled
                          >
                            Seleccione
                          </MenuItem>
                          {laboratorios.map((lab) => (
                            <MenuItem
                              key={lab.idLaboratorio}
                              value={lab.idLaboratorio}
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                            >
                              {lab.nombre || ""}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfCodigo"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                            ml: "0.3vw",
                          }}
                        >
                          Codigo:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={viewOnly || estudioSub === "no"}
                          value={codigoEstudioSub}
                          onChange={onCodigoEstudioSubChange}
                          required
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "12vw",
                              height: "5vh",
                              ml: "0.3vw",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfCodigo"
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="txfCosto"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Costo:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={viewOnly || estudioSub === "no"}
                          value={costoSub}
                          onChange={onCostoSubChange}
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "9vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfCosto"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfTiempoEntrega"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Tiempo de entrega:
                        </InputLabel>
                        <Stack direction="row" spacing={"-1vw"}>
                          <TextField
                            fullWidth
                            disabled={viewOnly || estudioSub === "no"}
                            value={tiempoEntregaSub}
                            onChange={onTiempoEntregaSubChange}
                            required
                            sx={{
                              "& .MuiInputBase-root": {
                                width: "10vw",
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfTiempoEntrega"
                          />
                          <Select
                            input={<OutlinedInput />}
                            disabled={viewOnly || estudioSub === "no"}
                            value={tiempoEntregaSubDH}
                            onChange={onTiempoEntregaSubDHChange}
                            sx={{
                              width: "9vw",
                              maxWidth: "100%",

                              height: "5vh",
                              minHeight: "0px !important",
                              overflow: "hidden",

                              "&.MuiInputBase-root": {
                                minHeight: "0px !important",
                              },

                              "& .MuiSelect-select": {
                                minHeight: "0px !important",
                                padding: "0 0.5vw !important",
                                display: "flex",
                                alignItems: "center",
                                fontSize: "1vw",
                                lineHeight: "1",
                              },

                              "& .MuiOutlinedInput-notchedOutline": {
                                top: 0,
                                "& legend": { display: "none" },
                              },

                              "& .MuiSvgIcon-root": {
                                display: "inline-block !important",
                                position: "absolute",
                                right: "0.5vw",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "1.2vw !important",
                                width: "1.2vw !important",
                                height: "1.2vw !important",
                                pointerEvents: "none",
                              },
                              minWidth: "0px !important",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                            className="selectTiempoEntrega"
                          >
                            <MenuItem
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                              value="seleccione"
                              disabled
                            >
                              Seleccione
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                              value="dias"
                            >
                              Dia(s)
                            </MenuItem>
                            <MenuItem
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                              value="horas"
                            >
                              Hora(s)
                            </MenuItem>
                          </Select>
                        </Stack>
                      </Grid>
                    </Stack>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"2vw"}
                      sx={{ paddingTop: "0vw" }}
                    >
                      {/* Volvemos a dejar el Stack normal para que las columnas tengan la misma altura */}
                      <Stack direction="row" spacing={"3vw"}>
                        <Grid item xs={6}>
                          <Typography
                            sx={{
                              fontSize: "0.9vw",
                              fontWeight: "bold",
                              mb: 1,
                            }}
                          >
                            Leyenda/Observaciones del estudio:
                          </Typography>
                          <ReactQuill
                            theme="snow"
                            value={observacionesEstudio}
                            onChange={onObservacionesEstudioChange}
                            readOnly={viewOnly}
                            style={{
                              minHeight: "8vh",
                              height: "auto",
                              width: "40vw",
                              color: viewOnly ? "gray" : "black",
                            }}
                          />
                        </Grid>
                      </Stack>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"2vw"}
                      sx={{ paddingTop: "0.4vw" }}
                    >
                      {/* Volvemos a dejar el Stack normal para que las columnas tengan la misma altura */}
                      <Stack direction="row" spacing={"3vw"}>
                        <Grid item xs={6}>
                          <Typography
                            sx={{
                              fontSize: "0.9vw",
                              fontWeight: "bold",
                              mb: 1,
                            }}
                          >
                            Descripcion cientifica sobre la aplicacion y
                            funcionamiento del estudio:
                          </Typography>
                          <ReactQuill
                            theme="snow"
                            value={descripcionEstudio}
                            readOnly={viewOnly}
                            onChange={onDescripcionEstudioChange}
                            style={{
                              minHeight: "8vh",
                              height: "auto",
                              width: "40vw",
                              color: viewOnly ? "gray" : "black",
                            }}
                          />
                        </Grid>
                      </Stack>
                    </Grid>
                  </Grid>
                </Paper>
              </Stack>
              <Paper
                elevation={3}
                sx={{ p: 2, borderRadius: 4, marginTop: "2vh" }}
                className="paperDoc"
              >
                <Typography
                  variant="h7"
                  fontWeight="bold"
                  gutterBottom
                  sx={{
                    background: "linear-gradient(90deg, #006787, #014e65)",
                    color: "white",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    display: "inline-block",
                    fontWeight: "bold"
                  }}
                >
                  PARAMETROS DEL ESTUDIO:
                </Typography>

                <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                  {" "}
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Parametro
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Unidad de medida
                      </TableCell>

                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                        colSpan={2}
                      >
                        Factor de conversion
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Tipo de valor de referencia
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Acciones
                      </TableCell>
                    </TableRow>
                    <TableRow>

                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        FC
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        UI
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderRight: "1px solid #ccc",
                        }}
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {parametros.length > 0 ? (
                      parametros.map((parametro, index) => (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <TextField
                                  value={parametro.parametro}
                                  disabled={viewOnly}
                                  onChange={(e) =>
                                    handleChangeParametro(
                                      index,
                                      "parametro",
                                      e.target.value,
                                    )
                                  }
                                  sx={{
                                    width: "12.5vw",
                                    "& .MuiInputBase-root": {
                                      height: "5vh",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <TextField
                                  value={parametro.unidadMedida}
                                  disabled={viewOnly}
                                  onChange={(e) =>
                                    handleChangeParametro(
                                      index,
                                      "unidadMedida",
                                      e.target.value,
                                    )
                                  }
                                  sx={{
                                    width: "6vw",
                                    "& .MuiInputBase-root": {
                                      height: "5vh",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <TextField
                                  value={parametro.fc}
                                  disabled={viewOnly}
                                  onChange={(e) =>
                                    handleChangeParametro(
                                      index,
                                      "fc",
                                      e.target.value,
                                    )
                                  }
                                  sx={{
                                    width: "4vw",
                                    "& .MuiInputBase-root": {
                                      height: "5vh",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <TextField
                                  value={parametro.ui}
                                  disabled={viewOnly}
                                  onChange={(e) =>
                                    handleChangeParametro(
                                      index,
                                      "ui",
                                      e.target.value,
                                    )
                                  }
                                  sx={{
                                    width: "4vw",
                                    "& .MuiInputBase-root": {
                                      height: "5vh",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <FormControl>
                                  <RadioGroup
                                    row
                                    value={parametro.tipoReferencia}
                                    onChange={(e) =>
                                      handleTipoValorChange(
                                        index,
                                        e.target.value,
                                      )
                                    }
                                    disabled={viewOnly}
                                  >
                                    <FormControlLabel
                                      sx={{
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "1vw",
                                          fontFamily: "Roboto-Regular",
                                        },
                                      }}
                                      value="intervaloBR"
                                      control={
                                        <Radio
                                          disabled={viewOnly}
                                          sx={{
                                            "& .MuiSvgIcon-root": {
                                              height: "1vw",
                                              width: "1vw",
                                            },
                                          }}
                                        />
                                      }
                                      label="Intervalo BR"
                                    />
                                    <FormControlLabel
                                      sx={{
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "1vw",
                                          fontFamily: "Roboto-Regular",
                                        },
                                      }}
                                      value="mixto"
                                      control={
                                        <Radio
                                          disabled={viewOnly}
                                          sx={{
                                            "& .MuiSvgIcon-root": {
                                              height: "1vw",
                                              width: "1vw",
                                            },
                                          }}
                                        />
                                      }
                                      label="Mixto"
                                    />
                                    <FormControlLabel
                                      sx={{
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "1vw",
                                          fontFamily: "Roboto-Regular",
                                        },
                                      }}
                                      value="criterioR"
                                      control={
                                        <Radio
                                          disabled={viewOnly}
                                          sx={{
                                            "& .MuiSvgIcon-root": {
                                              height: "1vw",
                                              width: "1vw",
                                            },
                                          }}
                                        />
                                      }
                                      label="Criterio R"
                                    />
                                    <FormControlLabel
                                      sx={{
                                        "& .MuiFormControlLabel-label": {
                                          fontSize: "1vw",
                                          fontFamily: "Roboto-Regular",
                                        },
                                      }}
                                      value="sinValor"
                                      control={
                                        <Radio
                                          disabled={viewOnly}
                                          sx={{
                                            "& .MuiSvgIcon-root": {
                                              height: "1vw",
                                              width: "1vw",
                                            },
                                          }}
                                        />
                                      }
                                      label="Sin valor de referencia"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Stack
                                direction="row"
                                spacing={0.5}
                                alignItems="center"
                                justifyContent="center"
                              >
                                <Tooltip title="Subir parámetro">
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={viewOnly || index === 0}
                                      onClick={() => moverParametroArriba(index)}
                                      sx={{
                                        color: "#006787",
                                        border: "1px solid #006787",
                                        borderRadius: "6px",
                                        width: 32,
                                        height: 32,
                                        "&:hover": {
                                          backgroundColor: "rgba(0, 103, 135, 0.1)",
                                        },
                                        "&.Mui-disabled": {
                                          color: "#ccc",
                                          borderColor: "#ccc",
                                        },
                                      }}
                                    >
                                      <KeyboardArrowUpIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                                <Tooltip title="Bajar parámetro">
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={
                                        viewOnly ||
                                        index === parametros.length - 1
                                      }
                                      onClick={() => moverParametroAbajo(index)}
                                      sx={{
                                        color: "#006787",
                                        border: "1px solid #006787",
                                        borderRadius: "6px",
                                        width: 32,
                                        height: 32,
                                        "&:hover": {
                                          backgroundColor: "rgba(0, 103, 135, 0.1)",
                                        },
                                        "&.Mui-disabled": {
                                          color: "#ccc",
                                          borderColor: "#ccc",
                                        },
                                      }}
                                    >
                                      <KeyboardArrowDownIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                                <Button
                                  size="large"
                                  disabled={viewOnly}
                                  sx={{ color: "red", minWidth: 32 }}
                                  onClick={() =>
                                    handleRemoveParametro
                                      ? handleRemoveParametro(index)
                                      : null
                                  }
                                >
                                  <DeleteIcon sx={{ fontSize: "1.5vw" }} />
                                </Button>
                              </Stack>
                            </TableCell>
                          </TableRow>

                          {parametro.tipoReferencia === "mixto" && (
                            <TableRow>
                              <TableCell colSpan={7}>
                                <Box
                                  sx={{
                                    p: 0.8,
                                    backgroundColor: "#f5f5f5",
                                    borderRadius: 2,
                                    border: "1px solid #b8b8b8",
                                    overflow: "hidden"
                                  }}
                                >
                                  <Grid container sx={{ width: "100%", borderCollapse: "collapse" }}>
                                    {/* Column 1: Agregar nuevo valor */}
                                    <Grid item xs={3.5} sx={{ borderRight: "1px solid #b8b8b8", display: "flex", flexDirection: "column" }}>
                                      <Box sx={{ backgroundColor: "#2e2e2e", color: "white", py: 1, px: 2, display: "flex", justifyContent: "center", alignItems: "center", minHeight: "3.5vw" }}>
                                        <Typography sx={{ fontSize: "0.85vw", fontWeight: "bold", fontFamily: "Roboto", textTransform: "uppercase" }}>
                                          Agregar nuevo valor
                                        </Typography>
                                      </Box>
                                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", p: 2, minHeight: "220px", flexGrow: 1 }}>
                                        <TextField
                                          placeholder="Nombre del valor"
                                          variant="outlined"
                                          size="small"
                                          disabled={viewOnly}
                                          value={parametro.nuevoValorInput || ""}
                                          onChange={(e) => handleChangeParametro(index, "nuevoValorInput", e.target.value)}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault();
                                              addValorALista(index);
                                            }
                                          }}
                                          sx={{
                                            width: "90%",
                                            mb: 2,
                                            "& .MuiInputBase-root": {
                                              height: "5vh",
                                              backgroundColor: "white"
                                            },
                                            "& .MuiInputBase-input": {
                                              fontSize: "1vw",
                                            }
                                          }}
                                        />
                                        <Button
                                          variant="contained"
                                          size="small"
                                          disabled={viewOnly}
                                          onClick={() => addValorALista(index)}
                                          startIcon={<AddIcon />}
                                          sx={{
                                            backgroundColor: "#5cb85c",
                                            color: "#fff",
                                            textTransform: "none",
                                            fontSize: "1vw",
                                            fontWeight: "normal",
                                            borderRadius: "4px",
                                            padding: "4px 12px",
                                            "&:hover": {
                                              backgroundColor: "#4cae4c",
                                            }
                                          }}
                                        >
                                          Agregar valor
                                        </Button>
                                      </Box>
                                    </Grid>

                                    {/* Column 2: Valores posibles del parámetro */}
                                    <Grid item xs={4.5} sx={{ borderRight: "1px solid #b8b8b8", display: "flex", flexDirection: "column" }}>
                                      <Box sx={{ backgroundColor: "#2e2e2e", color: "white", py: 1, px: 2, display: "flex", justifyContent: "center", alignItems: "center", minHeight: "3.5vw" }}>
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                          <Typography sx={{ fontSize: "0.85vw", fontWeight: "bold", fontFamily: "Roboto", textTransform: "uppercase", mr: 0.5 }}>
                                            Valores posibles del parámetro
                                          </Typography>
                                          <Tooltip title="Lista de valores posibles para este parámetro. Haga clic en un valor para seleccionarlo y establecerlo como predeterminado." arrow>
                                            <Box sx={{ cursor: "help", backgroundColor: "white", color: "#2e2e2e", borderRadius: "50%", width: "1.1vw", height: "1.1vw", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "0.75vw", fontWeight: "bold" }}>
                                              ?
                                            </Box>
                                          </Tooltip>
                                        </Box>
                                      </Box>
                                      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 2, minHeight: "220px", flexGrow: 1 }}>
                                        <Box
                                          sx={{
                                            width: "95%",
                                            height: "140px",
                                            border: "1px solid #b8b8b8",
                                            backgroundColor: "white",
                                            overflowY: "auto",
                                            mb: 1.5
                                          }}
                                        >
                                          <List dense disablePadding>
                                            {(parametro.valoresPosibles || []).map((val, valIdx) => (
                                              <ListItem
                                                key={valIdx}
                                                disablePadding
                                                sx={{
                                                  backgroundColor: parametro.valorSeleccionadoList === val ? "#d9edf7" : "transparent"
                                                }}
                                              >
                                                <ListItemButton
                                                  disabled={viewOnly}
                                                  onClick={() => handleSelectValorDeLista(index, val)}
                                                  sx={{ py: 0.2, px: 1 }}
                                                >
                                                  <ListItemText
                                                    primary={val}
                                                    primaryTypographyProps={{
                                                      fontSize: "0.85vw",
                                                      fontFamily: "Roboto",
                                                      style: { wordBreak: "break-all" }
                                                    }}
                                                  />
                                                </ListItemButton>
                                              </ListItem>
                                            ))}
                                          </List>
                                        </Box>
                                        <Button
                                          variant="contained"
                                          size="small"
                                          disabled={viewOnly || !parametro.valorSeleccionadoList}
                                          onClick={() => removeValorDeLista(index)}
                                          startIcon={<RemoveIcon />}
                                          sx={{
                                            backgroundColor: "#ab3b3b",
                                            color: "#fff",
                                            textTransform: "none",
                                            fontSize: "1vw",
                                            fontWeight: "normal",
                                            borderRadius: "4px",
                                            padding: "4px 12px",
                                            "&:hover": {
                                              backgroundColor: "#962f2f",
                                            }
                                          }}
                                        >
                                          Quitar valor seleccionado de la lista.
                                        </Button>
                                      </Box>
                                    </Grid>

                                    {/* Column 3: Valor Predeterminado/Referencia */}
                                    <Grid item xs={4} sx={{ display: "flex", flexDirection: "column" }}>
                                      <Box sx={{ backgroundColor: "#2e2e2e", color: "white", py: 1, px: 2, display: "flex", justifyContent: "center", alignItems: "center", minHeight: "3.5vw" }}>
                                        <Typography sx={{ fontSize: "0.85vw", fontWeight: "bold", fontFamily: "Roboto", textTransform: "uppercase" }}>
                                          Valor Predeterminado/Referencia
                                        </Typography>
                                      </Box>
                                      <Box sx={{ display: "flex", flexDirection: "column", p: 2, minHeight: "220px", justifyContent: "space-between", flexGrow: 1 }}>
                                        {/* Sub-section 1: Valor Predeterminado */}
                                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                                          <Typography sx={{ fontSize: "1vw", fontWeight: "bold", mb: 1, textAlign: "center", fontFamily: "Roboto" }}>
                                            Seleccione de la lista el <span style={{ textDecoration: "underline" }}>VALOR PREDETERMINADO</span>
                                          </Typography>
                                          <TextField
                                            placeholder="Valor predeterminado"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            slotProps={{
                                              input: {
                                                readOnly: true,
                                              }
                                            }}
                                            value={parametro.valorPredeterminado || ""}
                                            sx={{
                                              width: "90%",
                                              mb: 1,
                                              "& .MuiInputBase-root": {
                                                backgroundColor: "#f5f5f5",
                                                height: "5vh",
                                              },
                                              "& .MuiInputBase-input": {
                                                fontSize: "1vw",
                                                textAlign: "center"
                                              }
                                            }}
                                          />
                                          <Button
                                            variant="contained"
                                            size="small"
                                            disabled={viewOnly || !parametro.valorPredeterminado}
                                            onClick={() => clearValorPredeterminado(index)}
                                            startIcon={<CancelIcon />}
                                            sx={{
                                              backgroundColor: "#ab3b3b",
                                              color: "#fff",
                                              textTransform: "none",
                                              fontSize: "0.75vw",
                                              fontWeight: "normal",
                                              borderRadius: "4px",
                                              padding: "2px 8px",
                                              "&:hover": {
                                                backgroundColor: "#962f2f",
                                              }
                                            }}
                                          >
                                            Eliminar valor predeterminado
                                          </Button>
                                        </Box>

                                        <Box sx={{ borderBottom: "1px solid #dcdcdc", my: 1.5, width: "100%" }} />

                                        {/* Sub-section 2: Valor de Referencia */}
                                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                                          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "95%", mb: 1 }}>
                                            <Typography sx={{ fontSize: "1vw", fontWeight: "bold", mr: 1, whiteSpace: "nowrap", fontFamily: "Roboto" }}>
                                              Coloque el <span style={{ textDecoration: "underline" }}>VALOR DE REFERENCIA</span>
                                            </Typography>
                                            <TextField
                                              placeholder="Valor de Referencia"
                                              variant="outlined"
                                              size="small"
                                              disabled={viewOnly}
                                              value={parametro.valorReferencia || ""}
                                              onChange={(e) => handleChangeParametro(index, "valorReferencia", e.target.value)}
                                              sx={{
                                                flexGrow: 1,
                                                "& .MuiInputBase-root": {
                                                  backgroundColor: "white",
                                                  height: "5vh",
                                                },
                                                "& .MuiInputBase-input": {
                                                  fontSize: "1vw",
                                                }
                                              }}
                                            />
                                          </Box>
                                          <Button
                                            variant="contained"
                                            size="small"
                                            disabled={viewOnly || !parametro.valorReferencia}
                                            onClick={() => clearValorReferencia(index)}
                                            startIcon={<CancelIcon />}
                                            sx={{
                                              backgroundColor: "#ab3b3b",
                                              color: "#fff",
                                              textTransform: "none",
                                              fontSize: "0.75vw",
                                              fontWeight: "normal",
                                              borderRadius: "4px",
                                              padding: "2px 8px",
                                              "&:hover": {
                                                backgroundColor: "#962f2f",
                                              }
                                            }}
                                          >
                                            Eliminar valor de referencia
                                          </Button>
                                        </Box>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </TableCell>
                            </TableRow>
                          )}

                          {parametro.tipoReferencia === "criterioR" && (
                            <TableRow>
                              <TableCell colSpan={7}>
                                <Box
                                  sx={{
                                    p: 0.8,
                                    backgroundColor: "#f5f5f5",
                                    borderRadius: 2,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "0.9vw",
                                      fontWeight: "bold",
                                      mb: 1,
                                    }}
                                  >
                                    Introduce el texto que sera el valor de
                                    referencia:
                                  </Typography>
                                  <ReactQuill
                                    theme="snow"
                                    readOnly={viewOnly}
                                    value={parametro.valorReferencia || ""}
                                    onChange={(content) =>
                                      handleChangeParametro(
                                        index,
                                        "valorReferencia",
                                        content,
                                      )
                                    }
                                    style={{
                                      minHeight: "8vh",
                                      height: "auto",
                                      width: "40vw",
                                      color: viewOnly ? "gray" : "black",
                                    }}
                                  />
                                </Box>
                              </TableCell>
                            </TableRow>
                          )}

                          {parametro.tipoReferencia === "intervaloBR" && (
                            <TableRow>
                              <TableCell colSpan={7}>
                                <Box
                                  sx={{
                                    p: 0.8,
                                    backgroundColor: "#f5f5f5",
                                    borderRadius: 2,
                                  }}
                                >
                                  {(parametro.intervalosBR || []).map(
                                    (intervalo, intervaloIndex) => (
                                      <Box
                                        key={intervaloIndex}
                                        sx={{
                                          mb: 1,
                                          border: "1px solid #b8b8b8",
                                          borderRadius: 1,
                                          backgroundColor: "#ffffff",
                                        }}
                                      >
                                        <Table
                                          sx={{
                                            borderCollapse: "collapse",
                                            width: "100%",
                                          }}
                                          size="small"
                                        >
                                          <TableHead>
                                            <TableRow>
                                              <TableCell
                                                sx={{
                                                  backgroundColor: "#e0e0e0",
                                                  fontSize: "1.2vw",
                                                  fontFamily: "Roboto",
                                                  fontWeight: 700,
                                                  borderBottom:
                                                    "1px solid #b8b8b8",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  Intervalo
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{
                                                  backgroundColor: "#e0e0e0",
                                                  fontSize: "1.2vw",
                                                  fontFamily: "Roboto",
                                                  fontWeight: 700,
                                                  borderBottom:
                                                    "1px solid #b8b8b8",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  Género
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{
                                                  backgroundColor: "#e0e0e0",
                                                  fontSize: "1.2vw",
                                                  fontFamily: "Roboto",
                                                  fontWeight: 700,
                                                  borderBottom:
                                                    "1px solid #b8b8b8",
                                                  textAlign: "center",
                                                  verticalAlign: "middle",
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  Edad
                                                </Box>
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            <TableRow>
                                              <TableCell
                                                sx={{
                                                  borderBottom:
                                                    "1px solid #b8b8b8",
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    gap: 0.6,
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                  }}
                                                >
                                                  <IconButton
                                                    size="small"
                                                    disabled={viewOnly}
                                                    onClick={() =>
                                                      removeIntervaloBR(
                                                        index,
                                                        intervaloIndex,
                                                      )
                                                    }
                                                    sx={{
                                                      color: "red",
                                                      p: 0.5,
                                                      minWidth: "2.4vw",
                                                    }}
                                                  >
                                                    <DeleteIcon
                                                      sx={{ fontSize: "2vw" }}
                                                    />
                                                  </IconButton>
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <Typography
                                                      sx={{
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                        mb: 0.2,
                                                      }}
                                                    >
                                                      De:
                                                    </Typography>
                                                    <TextField
                                                      placeholder=""
                                                      value={intervalo.intervaloMin || ""}
                                                      disabled={viewOnly}
                                                      onChange={(e) =>
                                                        handleChangeIntervaloBR(
                                                          index,
                                                          intervaloIndex,
                                                          "intervaloMin",
                                                          e.target.value,
                                                        )
                                                      }
                                                      sx={{
                                                        "& .MuiInputBase-root":
                                                        {
                                                          height: "5vh",
                                                          width: "8vw",
                                                        },
                                                        "& .MuiInputBase-input":
                                                        {
                                                          fontSize: "1vw",
                                                          padding:
                                                            "0.4vw 0.6vw",
                                                        },
                                                      }}
                                                    />
                                                  </Box>
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <Typography
                                                      sx={{
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                        mb: 0.2,
                                                      }}
                                                    >
                                                      A:
                                                    </Typography>
                                                    <TextField
                                                      placeholder=""
                                                      size="small"
                                                      value={intervalo.intervaloMax || ""}
                                                      disabled={viewOnly}
                                                      onChange={(e) =>
                                                        handleChangeIntervaloBR(
                                                          index,
                                                          intervaloIndex,
                                                          "intervaloMax",
                                                          e.target.value,
                                                        )
                                                      }
                                                      sx={{
                                                        "& .MuiInputBase-root":
                                                        {
                                                          height: "5vh",
                                                          width: "8vw",
                                                        },
                                                        "& .MuiInputBase-input":
                                                        {
                                                          fontSize: "1vw",
                                                          padding:
                                                            "0.4vw 0.6vw",
                                                        },
                                                      }}
                                                    />
                                                  </Box>
                                                </Box>
                                              </TableCell>
                                              <TableCell
                                                sx={{
                                                  borderBottom:
                                                    "1px solid #b8b8b8",
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    fontSize: "0.72vw",
                                                    fontWeight: 700,
                                                    mb: 0.25,
                                                  }}
                                                >
                                                  Aplica para:
                                                </Typography>
                                                <RadioGroup
                                                  row
                                                  value={
                                                    intervalo.genero || "ambos"
                                                  }
                                                  onChange={(e) =>
                                                    handleChangeIntervaloBR(
                                                      index,
                                                      intervaloIndex,
                                                      "genero",
                                                      e.target.value,
                                                    )
                                                  }
                                                  disabled={viewOnly}
                                                  sx={{ gap: 1.2 }}
                                                >
                                                  <FormControlLabel
                                                    value="hombre"
                                                    control={
                                                      <Radio
                                                        sx={{ p: 0 }}
                                                        disabled={viewOnly}
                                                      />
                                                    }
                                                    label="Hombre"
                                                    sx={{
                                                      "& .MuiFormControlLabel-label":
                                                      {
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                      },
                                                      mr: 0.5,
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    value="mujer"
                                                    control={
                                                      <Radio
                                                        sx={{ p: 0 }}
                                                        disabled={viewOnly}
                                                      />
                                                    }
                                                    label="Mujer"
                                                    sx={{
                                                      "& .MuiFormControlLabel-label":
                                                      {
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                      },
                                                      mr: 0.5,
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    value="ambos"
                                                    control={
                                                      <Radio
                                                        sx={{ p: 0 }}
                                                        disabled={viewOnly}
                                                      />
                                                    }
                                                    label="Ambos"
                                                    sx={{
                                                      "& .MuiFormControlLabel-label":
                                                      {
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                      },
                                                    }}
                                                  />
                                                </RadioGroup>
                                              </TableCell>
                                              <TableCell
                                                sx={{
                                                  borderBottom:
                                                    "1px solid #b8b8b8",
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "flex",
                                                    gap: 0.6,
                                                    flexWrap: "wrap",
                                                    mb: 0.3,
                                                  }}
                                                >
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <Typography
                                                      sx={{
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                        mb: 0.2,
                                                      }}
                                                    >
                                                      De:
                                                    </Typography>
                                                    <TextField
                                                      placeholder=""
                                                      size="small"
                                                      value={
                                                        intervalo.edadMin || ""
                                                      }
                                                      disabled={viewOnly}
                                                      onChange={(e) =>
                                                        handleChangeIntervaloBR(
                                                          index,
                                                          intervaloIndex,
                                                          "edadMin",
                                                          e.target.value,
                                                        )
                                                      }
                                                      sx={{
                                                        "& .MuiInputBase-root":
                                                        {
                                                          height: "5vh",
                                                          width: "8vw",
                                                        },
                                                        "& .MuiInputBase-input":
                                                        {
                                                          fontSize: "1vw",
                                                          padding:
                                                            "0.4vw 0.6vw",
                                                        },
                                                      }}
                                                    />
                                                  </Box>
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                      alignItems: "flex-start",
                                                    }}
                                                  >
                                                    <Typography
                                                      sx={{
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                        mb: 0.2,
                                                      }}
                                                    >
                                                      A:
                                                    </Typography>
                                                    <TextField
                                                      placeholder=""
                                                      size="small"
                                                      value={
                                                        intervalo.edadMax || ""
                                                      }
                                                      disabled={viewOnly}
                                                      onChange={(e) =>
                                                        handleChangeIntervaloBR(
                                                          index,
                                                          intervaloIndex,
                                                          "edadMax",
                                                          e.target.value,
                                                        )
                                                      }
                                                      sx={{
                                                        width: "5.5vw",
                                                        "& .MuiInputBase-root":
                                                        {
                                                          height: "5vh",
                                                          width: "8vw",
                                                        },
                                                        "& .MuiInputBase-input":
                                                        {
                                                          fontSize: "1vw",
                                                          padding:
                                                            "0.4vw 0.6vw",
                                                        },
                                                      }}
                                                    />
                                                  </Box>
                                                </Box>
                                                <RadioGroup
                                                  row
                                                  value={
                                                    intervalo.tipoUnidad ||
                                                    "Años"
                                                  }
                                                  onChange={(e) =>
                                                    handleChangeIntervaloBR(
                                                      index,
                                                      intervaloIndex,
                                                      "tipoUnidad",
                                                      e.target.value,
                                                    )
                                                  }
                                                  disabled={viewOnly}
                                                  sx={{ gap: 1.2 }}
                                                >
                                                  <FormControlLabel
                                                    value="Días"
                                                    control={
                                                      <Radio
                                                        sx={{ p: 0 }}
                                                        disabled={viewOnly}
                                                      />
                                                    }
                                                    label="Días"
                                                    sx={{
                                                      "& .MuiFormControlLabel-label":
                                                      {
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                      },
                                                      mr: 0.5,
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    value="Meses"
                                                    control={
                                                      <Radio
                                                        sx={{ p: 0 }}
                                                        disabled={viewOnly}
                                                      />
                                                    }
                                                    label="Meses"
                                                    sx={{
                                                      "& .MuiFormControlLabel-label":
                                                      {
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                      },
                                                      mr: 0.5,
                                                    }}
                                                  />
                                                  <FormControlLabel
                                                    value="Años"
                                                    control={
                                                      <Radio
                                                        sx={{ p: 0 }}
                                                        disabled={viewOnly}
                                                      />
                                                    }
                                                    label="Años"
                                                    sx={{
                                                      "& .MuiFormControlLabel-label":
                                                      {
                                                        fontSize: "0.72vw",
                                                        fontWeight: 700,
                                                      },
                                                    }}
                                                  />
                                                </RadioGroup>
                                              </TableCell>
                                            </TableRow>
                                          </TableBody>
                                        </Table>

                                        <Box sx={{ mt: 1 }}>
                                          <Table
                                            sx={{
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                            size="small"
                                          >
                                            <TableHead>
                                              <TableRow>
                                                <TableCell
                                                  sx={{
                                                    backgroundColor: "#e0e0e0",
                                                    fontSize: "1.2vw",
                                                    fontFamily: "Roboto",
                                                    fontWeight: 700,
                                                    borderBottom:
                                                      "1px solid #b8b8b8",
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                  }}
                                                >
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    Niveles de decisión
                                                  </Box>
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    backgroundColor: "#e0e0e0",
                                                    fontSize: "1.2vw",
                                                    fontFamily: "Roboto",
                                                    fontWeight: 700,
                                                    borderBottom:
                                                      "1px solid #b8b8b8",
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                  }}
                                                >
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                    }}
                                                  >
                                                    Valor crítico
                                                  </Box>
                                                </TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              <TableRow>
                                                <TableCell
                                                  sx={{
                                                    borderBottom:
                                                      "1px solid #b8b8b8",
                                                  }}
                                                >
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      gap: 0.3,
                                                      flexWrap: "wrap",
                                                      width: "100%",
                                                    }}
                                                  >
                                                    {[1, 2, 3, 4, 5].map(
                                                      (n) => (
                                                        <Box
                                                          key={n}
                                                          sx={{
                                                            display: "flex",
                                                            flexDirection:
                                                              "column",
                                                            alignItems:
                                                              "center",
                                                            minWidth: "3.2vw",
                                                          }}
                                                        >
                                                          <Box
                                                            sx={{
                                                              width: "6vw",
                                                              height: "1.7vw",
                                                              backgroundColor:
                                                                "#2D89A2",
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                              justifyContent:
                                                                "center",
                                                              mb: 0.25,
                                                            }}
                                                          >
                                                            <Typography
                                                              sx={{
                                                                fontSize:
                                                                  "0.72vw",
                                                                fontWeight: 700,
                                                                color: "#000",
                                                              }}
                                                            >
                                                              {n}
                                                            </Typography>
                                                          </Box>
                                                          <TextField
                                                            size="small"
                                                            value={
                                                              intervalo[
                                                              `nivelD${n}`
                                                              ] || ""
                                                            }
                                                            disabled={viewOnly}
                                                            onChange={(e) =>
                                                              handleChangeIntervaloBR(
                                                                index,
                                                                intervaloIndex,
                                                                `nivelD${n}`,
                                                                e.target.value,
                                                              )
                                                            }
                                                            sx={{
                                                              "& .MuiInputBase-root":
                                                              {
                                                                height: "5vh",
                                                                width: "6vw",
                                                              },
                                                              "& .MuiInputBase-input":
                                                              {
                                                                fontSize:
                                                                  "1vw",
                                                                padding:
                                                                  "0.4vw 0.6vw",
                                                              },
                                                            }}
                                                          />
                                                        </Box>
                                                      ),
                                                    )}
                                                  </Box>
                                                </TableCell>
                                                <TableCell>
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      gap: 0.6,
                                                      flexWrap: "wrap",
                                                      mb: 0.3,
                                                    }}
                                                  >
                                                    <Box
                                                      sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                      }}
                                                    >
                                                      <Typography
                                                        sx={{
                                                          fontSize: "0.72vw",
                                                          fontWeight: 700,
                                                          mb: 0.2,
                                                        }}
                                                      >
                                                        Menor que:
                                                      </Typography>
                                                      <TextField
                                                        placeholder=""
                                                        size="small"
                                                        value={
                                                          intervalo.valorCMin ||
                                                          ""
                                                        }
                                                        disabled={viewOnly}
                                                        onChange={(e) =>
                                                          handleChangeIntervaloBR(
                                                            index,
                                                            intervaloIndex,
                                                            "valorCMin",
                                                            e.target.value,
                                                          )
                                                        }
                                                        sx={{
                                                          width: "8vw",
                                                          "& .MuiInputBase-root": {
                                                            height: "5vh",
                                                          },
                                                          "& .MuiInputBase-input": {
                                                            fontSize: "1vw",
                                                            padding:
                                                              "0.4vw 0.6vw",
                                                          },
                                                        }}
                                                      />
                                                    </Box>
                                                    <Box
                                                      sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                      }}
                                                    >
                                                      <Typography
                                                        sx={{
                                                          fontSize: "0.72vw",
                                                          fontWeight: 700,
                                                          mb: 0.2,
                                                        }}
                                                      >
                                                        Mayor que:
                                                      </Typography>
                                                      <TextField
                                                        placeholder=""
                                                        size="small"
                                                        value={
                                                          intervalo.valorCMax ||
                                                          ""
                                                        }
                                                        disabled={viewOnly}
                                                        onChange={(e) =>
                                                          handleChangeIntervaloBR(
                                                            index,
                                                            intervaloIndex,
                                                            "valorCMax",
                                                            e.target.value,
                                                          )
                                                        }
                                                        sx={{
                                                          width: "8vw",
                                                          "& .MuiInputBase-root": {
                                                            height: "5vh",
                                                          },
                                                          "& .MuiInputBase-input": {
                                                            fontSize: "1vw",
                                                            padding:
                                                              "0.4vw 0.6vw",
                                                          },
                                                        }}
                                                      />
                                                    </Box>
                                                  </Box>
                                                </TableCell>
                                              </TableRow>
                                            </TableBody>
                                          </Table>
                                        </Box>
                                      </Box>
                                    ),
                                  )}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      mt: 0.5,
                                    }}
                                  >
                                    <Button
                                      variant="contained"
                                      size="small"
                                      startIcon={<AddIcon sx={{ fontSize: "1rem" }} />}
                                      onClick={() => addIntervaloBR(index)}
                                      disabled={viewOnly}
                                      sx={{
                                        textTransform: "none",
                                        fontSize: "0.75vw",
                                        minWidth: "13vw",
                                        backgroundColor: "#4caf50",
                                        color: "#ffffff",
                                        '&:hover': {
                                          backgroundColor: "#388e3c",
                                        },
                                      }}
                                    >
                                      Agregar valor de referencia
                                    </Button>
                                  </Box>
                                </Box>
                              </TableCell>
                            </TableRow>
                          )}
                          <TableRow>
                            <TableCell colSpan={7}>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <TextField
                                  value={parametro.textoExtra}
                                  disabled={viewOnly}
                                  onChange={(e) =>
                                    handleChangeParametro(
                                      index,
                                      "textoExtra",
                                      e.target.value,
                                    )
                                  }
                                  multiline
                                  minRows={1}
                                  maxRows={4}
                                  sx={{
                                    width: "60vw",
                                    "& .MuiInputBase-root": {},
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                    },
                                  }}
                                />
                              </Box>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                          No hay registros
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "0.5vw",
                  }}
                >
                  <IconButton sx={{ color: "#006787" }} onClick={addParametro}>
                    Añadir parametro
                    <AddIcon />
                  </IconButton>
                </Box>
              </Paper>
            </TabPanel>

            <TabPanel value={activeTab} index={1}>
              <Stack spacing={2} sx={{ width: "95vw", maxWidth: "96vw" }}>
                <Paper
                  elevation={3}
                  sx={{ p: 2, borderRadius: 4, minHeight: "30vh" }}
                  className="paperEstudiosInt"
                >
                  <Grid container spacing={4}>
                    {/* Pregunta 1 */}
                    <Grid item xs={12}>
                      <Typography variant="h6" fontWeight="bold" gutterBottom>
                        ¿Se está registrando un examen con sub-exámenes?
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        Al seleccionar la opción Sí, en el módulo de Reporte de
                        Resultados; podrá capturar los resultados por separado
                        para cada uno de los estudios que lo integran. Así mismo
                        en el módulo de Entrega de Resultados podrá realizar la
                        impresión de forma individual de cada uno de los
                        estudios que lo conforman.
                      </Typography>
                      <RadioGroup
                        row
                        value={registroExamenSub}
                        onChange={onRegistroExamenSubChange}
                        disabled={viewOnly}
                      >
                        <FormControlLabel
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "1vw",
                              fontFamily: "Roboto-Regular",
                            },
                          }}
                          value="si"
                          control={
                            <Radio
                              disabled={viewOnly}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  height: "1vw",
                                  width: "1vw",
                                },
                              }}
                            />
                          }
                          label="Sí"
                        />
                        <FormControlLabel
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize: "1vw",
                              fontFamily: "Roboto-Regular",
                            },
                          }}
                          value="no"
                          control={
                            <Radio
                              disabled={viewOnly}
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  height: "1vw",
                                  width: "1vw",
                                },
                              }}
                            />
                          }
                          label="No"
                        />
                      </RadioGroup>
                    </Grid>
                    {/* Instrucciones */}
                    <Grid item xs={12}>
                      <Typography variant="h6" fontWeight="bold" gutterBottom>
                        Instrucciones
                      </Typography>
                      <Typography variant="body2">
                        <Box
                          component="span"
                          sx={{ fontSize: "2rem", verticalAlign: "middle" }}
                        >
                          •
                        </Box>{" "}
                        Para agregar el estudio deberá realizar la búsqueda por
                        su código o bien por nombre y seleccionarlo, pasando de
                        forma automática a la lista que se muestra a la derecha.
                      </Typography>

                      <Typography variant="body2">
                        <Box
                          component="span"
                          sx={{ fontSize: "2rem", verticalAlign: "middle" }}
                        >
                          •
                        </Box>{" "}
                        Si desea eliminarlo, seleccione el estudio deseado de la
                        lista y dé clic en el botón Quitar estudio interno de la
                        lista.
                      </Typography>
                      <Typography variant="body2">
                        <Box
                          component="span"
                          sx={{ fontSize: "2rem", verticalAlign: "middle" }}
                        >
                          •
                        </Box>{" "}
                        Si desea cambiar el orden en el que se muestran los
                        estudios, seleccione las flechas ubicadas en el costado
                        derecho de la lista.
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
                <Paper
                  elevation={3}
                  sx={{ p: 2, borderRadius: 4 }}
                  className="paperEstudiosLista"
                >
                  <Stack
                    direction="row"
                    spacing={"4vw"}
                    sx={{ justifyContent: "center", alignItems: "center" }}
                  >
                    {/* Bloque izquierdo: Nombre y Código */}
                    <Grid
                      container
                      item
                      xs={4}
                      spacing={2}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Stack
                        direction="column"
                        spacing={"10vh"}
                        alignItems="center"
                      >
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <InputLabel
                              htmlFor="txfNombreEstudio"
                              sx={{
                                color: "black",
                                fontSize: "1vw",
                                fontWeight: "bold",
                              }}
                            >
                              Nombre del estudio:
                            </InputLabel>
                            <Autocomplete
                              options={nombres}
                              value={selectedNombre}
                              popupIcon={null}
                              getOptionKey={(option) => option.idEstudio}
                              getOptionLabel={(option) => {
                                if (!option) return "";
                                if (typeof option === "string") return option;
                                const nom = option.nombre || "";
                                const cod = option.codigo ? ` (${option.codigo})` : "";
                                return `${nom}${cod}`;
                              }}
                              renderOption={(props, option) => {
                                const { key, ...otherProps } = props;
                                const label = option
                                  ? `${option.nombre || ""}${option.codigo ? ` (${option.codigo})` : ""}`
                                  : "";
                                return (
                                  <li
                                    key={key || option.idEstudio}
                                    {...otherProps}
                                    style={{ fontSize: "0.9vw" }}
                                  >
                                    {label}
                                  </li>
                                );
                              }}
                              onChange={(event, value) => {
                                setSelectedNombre(value);
                                const id = value ? value.idEstudio : null;
                                setSelectedIdEstudio(id);
                                setEstudioIntegra(id ? id : "");
                                // Agregar a la lista derecha cuando se seleccione una opción
                                if (value) {
                                  agregarEstudioALaLista(value);
                                }
                              }}
                              isOptionEqualToValue={(option, value) =>
                                option.idEstudio ===
                                (value ? value.idEstudio : null)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: "5vh",
                                      width: "12.51vw",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                      padding: "0.5vw",
                                    },
                                  }}
                                  className="txfNombreEstudioInt"
                                />
                              )}
                              filterOptions={(options, state) =>
                                filterAndRankEstudios(options, state.inputValue)
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <InputLabel
                              htmlFor="txfCodigoEstudio"
                              sx={{
                                color: "black",
                                fontSize: "1vw",
                                fontWeight: "bold",
                              }}
                            >
                              Código del estudio:
                            </InputLabel>
                            <Autocomplete
                              options={nombres}
                              value={selectedCodigo}
                              popupIcon={null}
                              getOptionKey={(option) => option.idEstudio}
                              getOptionLabel={(option) => {
                                if (!option) return "";
                                if (typeof option === "string") return option;
                                const nom = option.nombre || "";
                                const cod = option.codigo ? ` (${option.codigo})` : "";
                                return `${nom}${cod}`;
                              }}
                              renderOption={(props, option) => {
                                const { key, ...otherProps } = props;
                                const label = option
                                  ? `${option.nombre || ""}${option.codigo ? ` (${option.codigo})` : ""}`
                                  : "";
                                return (
                                  <li
                                    key={key || option.idEstudio}
                                    {...otherProps}
                                    style={{ fontSize: "0.9vw" }}
                                  >
                                    {label}
                                  </li>
                                );
                              }}
                              onChange={(event, value) => {
                                setSelectedCodigo(value);
                                const id = value ? value.idEstudio : null;
                                setSelectedIdEstudio(id);
                                setEstudioIntegra(id ? id : "");
                                // Agregar a la lista derecha cuando se seleccione una opción
                                if (value) {
                                  agregarEstudioALaLista(value);
                                }
                              }}
                              isOptionEqualToValue={(option, value) =>
                                option.idEstudio ===
                                (value ? value.idEstudio : null)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiInputBase-root": {
                                      height: "5vh",
                                      width: "12.51vw",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                      padding: "0.5vw",
                                    },
                                  }}
                                  className="txfCodigoEstudioInt"
                                />
                              )}
                              filterOptions={(options, state) =>
                                filterAndRankEstudios(options, state.inputValue)
                              }
                            />
                          </Box>
                        </Grid>
                      </Stack>
                    </Grid>

                    {/* Bloque central: Lista + Flechas */}
                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <List
                        sx={{
                          width: "30vw",
                          border: "1px solid #ccc",
                          height: 336,
                          overflowY: "auto",
                        }}
                      >
                        {estudiosLista.length === 0 && (
                          <ListItem disablePadding>
                            <ListItemButton>
                              <ListItemText primary="(Sin estudios)" />
                            </ListItemButton>
                          </ListItem>
                        )}
                        {estudiosLista.map((est, idx) => {
                          const estId = getEstudioId(est);
                          const infoEstudio = nombres.find(
                            (n) => String(n.idEstudio) === String(estId)
                          );
                          const nombreDisplay =
                            est.nombre || infoEstudio?.nombre || "Sin nombre";
                          const codigoDisplay =
                            est.codigo || infoEstudio?.codigo || "";
                          const textoDisplay = codigoDisplay
                            ? `${nombreDisplay} (${codigoDisplay})`
                            : nombreDisplay;

                          return (
                            <ListItem
                              key={estId || idx}
                              disablePadding
                              secondaryAction={
                                <IconButton
                                  edge="end"
                                  aria-label="remove"
                                  sx={{ color: "red" }}
                                  onClick={() =>
                                    eliminarEstudioSeleccionado(estId)
                                  }
                                >
                                  <RemoveIcon />
                                </IconButton>
                              }
                            >
                              <ListItemButton
                                selected={selectedListaId === estId}
                                onClick={() => setSelectedListaId(estId)}
                              >
                                <ListItemText primary={textoDisplay} />
                              </ListItemButton>
                            </ListItem>
                          );
                        })}
                      </List>
                      {/* Botones de ordenamiento */}
                      <Stack
                        direction="column"
                        spacing={1}
                        sx={{ ml: 1 }}
                      >
                        <Tooltip title="Mover arriba">
                          <span>
                            <IconButton
                              disabled={
                                viewOnly ||
                                selectedListaId === null ||
                                estudiosLista.findIndex((e) => getEstudioId(e) === selectedListaId) <= 0
                              }
                              onClick={moverEstudioArriba}
                              sx={{
                                color: "#006787",
                                border: "1px solid #006787",
                                borderRadius: "8px",
                                width: 40,
                                height: 40,
                                "&:hover": {
                                  backgroundColor: "rgba(0, 103, 135, 0.1)",
                                },
                                "&.Mui-disabled": {
                                  color: "#ccc",
                                  borderColor: "#ccc",
                                },
                              }}
                            >
                              <KeyboardArrowUpIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Mover abajo">
                          <span>
                            <IconButton
                              disabled={
                                viewOnly ||
                                selectedListaId === null ||
                                estudiosLista.findIndex((e) => getEstudioId(e) === selectedListaId) >= estudiosLista.length - 1
                              }
                              onClick={moverEstudioAbajo}
                              sx={{
                                color: "#006787",
                                border: "1px solid #006787",
                                borderRadius: "8px",
                                width: 40,
                                height: 40,
                                "&:hover": {
                                  backgroundColor: "rgba(0, 103, 135, 0.1)",
                                },
                                "&.Mui-disabled": {
                                  color: "#ccc",
                                  borderColor: "#ccc",
                                },
                              }}
                            >
                              <KeyboardArrowDownIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </Stack>
                    </Grid>
                  </Stack>
                </Paper>
              </Stack>
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
              <Paper
                elevation={3}
                sx={{ p: 2, borderRadius: 4 }}
                className="paperDoc"
              >
                <Box sx={{ p: 2 }}>
                  <Grid container spacing={2}>
                    {sinonimos.map((item, index) => {
                      const valorSinonimo =
                        typeof item === "string"
                          ? item
                          : (item?.sinonimo ?? item?.nombre ?? "");
                      const keySinonimo =
                        typeof item === "object" && item !== null && item.idSinonimo
                          ? item.idSinonimo
                          : index;

                      return (
                        <Grid item xs={6} key={keySinonimo}>
                          <Box
                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                          >
                            <TextField
                              fullWidth
                              label={`Sinónimo #${index + 1}`}
                              value={valorSinonimo}
                              onChange={(e) =>
                                actualizarSinonimo(index, e.target.value)
                              }
                              disabled={viewOnly}
                            />
                            {!viewOnly && (
                              <IconButton
                                color="error"
                                onClick={() => eliminarSinonimo(index)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            )}
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>

                  {/* Botón debajo */}
                  {!viewOnly && (
                    <Box
                      sx={{ mt: 2, display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        variant="contained"
                        color="success"
                        onClick={agregarSinonimo}
                      >
                        + Agregar Sinónimo
                      </Button>
                    </Box>
                  )}
                </Box>
              </Paper>
            </TabPanel>
            <TabPanel value={activeTab} index={3}>
              <Paper
                elevation={3}
                sx={{ p: 2, borderRadius: 4 }}
                className="paperMuestrasEstudio"
              >
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"1vw"}
                  sx={{ paddingTop: "0vw" }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="h7"
                      fontWeight="bold"
                      gutterBottom
                      align="center"
                      sx={{
                        background: "linear-gradient(90deg, #006787, #014e65)",
                        color: "white",
                        padding: "0.5vw 1vw",
                        borderRadius: "8px",
                        display: "inline-block",
                        marginTop: "0vw",
                        fontWeight: "bold"
                      }}
                    >
                      MUESTRAS
                    </Typography>
                  </Box>
                </Grid>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={activeTabMuestras}
                    onChange={handleTabMuestrasChange}
                    aria-label="tabs muestras"
                    textColor="primary"
                    indicatorColor="primary"
                  >
                    <Tab
                      label="Parametros de la muestra"
                      id="tab-0"
                      aria-controls="tabpanel-0"
                      sx={{
                        color: "black",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "8px",
                        marginRight: "8px",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#d9eaf7",
                          color: "#006787",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#006787",
                          color: "white",
                        },
                      }}
                    />
                    <Tab
                      label="Condiciones del paciente"
                      id="tab-1"
                      aria-controls="tabpanel-1"
                      sx={{
                        color: "black",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "8px",
                        marginRight: "8px",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#d9eaf7",
                          color: "#006787",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#014e65",
                          color: "white",
                        },
                      }}
                    />
                  </Tabs>
                </Box>
                <TabPanel value={activeTabMuestras} index={0}>
                  <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                    {" "}
                    {etiquetas.map((etiqueta, index) => (
                      <React.Fragment key={index}>
                        <TableHead sx={{ backgroundColor: "#18234f" }}>
                          <TableRow>
                            <TableCell
                              sx={{
                                color: "white",
                                fontWeight: "bold",
                                borderBottom: "none",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              # Etiquetas
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white",
                                fontWeight: "bold",
                                borderBottom: "none",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              Abreviatura etiqueta:
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white",
                                fontWeight: "bold",
                                borderBottom: "none",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              Tipo de muestra:
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white",
                                fontWeight: "bold",
                                borderBottom: "none",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                gap={1}
                                mt="0.3vh"
                              >
                                <InputLabel
                                  sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    color: "white",
                                    fontSize: "1vw",
                                    fontWeight: "bold",
                                    marginTop: 0,
                                    lineHeight: 1,
                                  }}
                                >
                                  Tubo/Material:
                                </InputLabel>

                                <IconButton
                                  onClick={handleCrearNuevoMaterial}
                                  sx={{
                                    color: "#039f32",
                                    padding: 0,
                                    transition:
                                      "transform 0.2s ease, color 0.2s ease",
                                    "&:hover": {
                                      color: "#014e65",
                                      transform: "scale(1.5)",
                                    },
                                  }}
                                >
                                  <AddCircleIcon sx={{ fontSize: "1.1vw" }} />
                                </IconButton>
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white",
                                fontWeight: "bold",
                                borderBottom: "none",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              Vol/Cant:
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white",
                                fontWeight: "bold",
                                borderBottom: "none",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              U.M.:
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "white",
                                fontWeight: "bold",
                                borderBottom: "none",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              Asociacion:
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {etiquetas.length > 0 ? (
                            <>
                              <TableRow>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <TextField
                                      value={etiqueta.numEtiquetas}
                                      disabled={viewOnly}
                                      onChange={(e) =>
                                        handleChangeEtiqueta(
                                          index,
                                          "numEtiquetas",
                                          e.target.value,
                                        )
                                      }
                                      sx={{
                                        width: "6vw",
                                        "& .MuiInputBase-root": {
                                          height: "5vh",
                                        },
                                        "& .MuiInputBase-input": {
                                          fontSize: "1vw",
                                        },
                                      }}
                                    />
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <TextField
                                      value={etiqueta.abreviatura}
                                      disabled={viewOnly}
                                      onChange={(e) =>
                                        handleChangeEtiqueta(
                                          index,
                                          "abreviatura",
                                          e.target.value,
                                        )
                                      }
                                      sx={{
                                        width: "8vw",
                                        "& .MuiInputBase-root": {
                                          height: "5vh",
                                        },
                                        "& .MuiInputBase-input": {
                                          fontSize: "1vw",
                                        },
                                      }}
                                    />
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <TextField
                                      value={etiqueta.tipoMuestra}
                                      disabled={viewOnly}
                                      onChange={(e) =>
                                        handleChangeEtiqueta(
                                          index,
                                          "tipoMuestra",
                                          e.target.value,
                                        )
                                      }
                                      sx={{
                                        width: "16vw",
                                        "& .MuiInputBase-root": {
                                          height: "5vh",
                                        },
                                        "& .MuiInputBase-input": {
                                          fontSize: "1vw",
                                        },
                                      }}
                                    />
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    mt="0.3vh"
                                  >
                                    <Autocomplete
                                      options={materiales}
                                      disabled={viewOnly}
                                      value={
                                        materiales.find(
                                          (m) =>
                                            m.idMaterial ===
                                            etiqueta.idMaterial,
                                        ) || null
                                      }
                                      popupIcon={null}
                                      getOptionLabel={(option) =>
                                        (option && option.nombre) || ""
                                      }
                                      onChange={(event, value) => {
                                        handleChangeEtiqueta(
                                          index,
                                          "idMaterial",
                                          value ? value.idMaterial : null, // guardamos solo el id
                                        );
                                      }}
                                      isOptionEqualToValue={(option, value) =>
                                        option.idMaterial ===
                                        (value ? value.idMaterial : null)
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          fullWidth
                                          disabled={viewOnly}
                                          sx={{
                                            width: "10vw",
                                            "& .MuiInputBase-root": {
                                              height: "5vh",
                                            },
                                            "& .MuiInputBase-input": {
                                              fontSize: "1vw",
                                            },
                                          }}
                                          className="txfNombreEstudioInt"
                                        />
                                      )}
                                      filterOptions={(options, state) => {
                                        const input = (state.inputValue || "")
                                          .trim()
                                          .toLowerCase();
                                        if (!input) return options;
                                        return options.filter((opt) => {
                                          const combined =
                                            `${opt.nombre || ""}`.toLowerCase();
                                          return combined.includes(input);
                                        });
                                      }}
                                    />
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <TextField
                                      value={etiqueta.cantidad}
                                      disabled={viewOnly}
                                      onChange={(e) =>
                                        handleChangeEtiqueta(
                                          index,
                                          "cantidad",
                                          e.target.value,
                                        )
                                      }
                                      sx={{
                                        width: "4vw",
                                        "& .MuiInputBase-root": {
                                          height: "5vh",
                                        },
                                        "& .MuiInputBase-input": {
                                          fontSize: "1vw",
                                        },
                                      }}
                                    />
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <TextField
                                      value={etiqueta.um}
                                      disabled={viewOnly}
                                      onChange={(e) =>
                                        handleChangeEtiqueta(
                                          index,
                                          "um",
                                          e.target.value,
                                        )
                                      }
                                      sx={{
                                        width: "4vw",
                                        "& .MuiInputBase-root": {
                                          height: "5vh",
                                        },
                                        "& .MuiInputBase-input": {
                                          fontSize: "1vw",
                                        },
                                      }}
                                    />
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Select
                                      input={<OutlinedInput />}
                                      value={etiqueta.asociacion}
                                      disabled={viewOnly}
                                      onChange={(e) =>
                                        handleChangeEtiqueta(
                                          index,
                                          "asociacion",
                                          e.target.value,
                                        )
                                      }
                                      sx={{
                                        width: "6vw",
                                        maxWidth: "100%",
                                        height: "5vh",
                                        minHeight: "0px !important",
                                        overflow: "hidden",
                                        "&.MuiInputBase-root": {
                                          minHeight: "0px !important",
                                        },
                                        "& .MuiSelect-select": {
                                          minHeight: "0px !important",
                                          padding: "0 0.5vw !important",
                                          display: "flex",
                                          alignItems: "center",
                                          fontSize: "1vw",
                                          lineHeight: "1",
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          top: 0,
                                          "& legend": { display: "none" },
                                        },
                                        "& .MuiSvgIcon-root": {
                                          position: "absolute",
                                          right: "0.5vw",
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          fontSize: "1.2vw !important",
                                          width: "1.2vw !important",
                                          height: "1.2vw !important",
                                          pointerEvents: "none",
                                        },
                                        minWidth: "0px !important",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                      }}
                                      className="selectAsociacion"
                                    >
                                      <MenuItem
                                        sx={{
                                          fontSize: "1vw",
                                          padding: "0.5vw",
                                        }}
                                        value="si"
                                      >
                                        Si
                                      </MenuItem>
                                      <MenuItem
                                        sx={{
                                          fontSize: "1vw",
                                          padding: "0.5vw",
                                        }}
                                        value="no"
                                      >
                                        No
                                      </MenuItem>
                                    </Select>
                                  </Box>
                                </TableCell>

                                <IconButton
                                  onClick={() => handleRemoveEtiqueta(index)}
                                  sx={{ color: "red", marginTop: "1.4vw" }}
                                >
                                  <DeleteIcon
                                    sx={{
                                      fontSize: "1.8vw",
                                    }}
                                  />
                                </IconButton>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  colSpan={2}
                                  sx={{
                                    backgroundColor: "rgba(51, 129, 155, 0.59)",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Typography
                                      variant="h7"
                                      fontWeight="bold"
                                      gutterBottom
                                      align="center"
                                      sx={{
                                        fontWeight: "bold",
                                        color: "black",
                                        padding: "0.5vw 1vw",
                                        borderRadius: "8px",
                                        display: "inline-block",
                                        marginTop: "0vw",
                                      }}
                                    >
                                      Indicaciones para la toma
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell colSpan={5}>
                                  <ReactQuill
                                    theme="snow"
                                    value={etiqueta.indicacionesToma}
                                    readOnly={viewOnly}
                                    onChange={(content) =>
                                      handleChangeEtiqueta(
                                        index,
                                        "indicacionesToma",
                                        content,
                                      )
                                    }
                                    style={{
                                      minHeight: "8vh",
                                      height: "auto",
                                      width: "auto",
                                      color: viewOnly ? "gray" : "black",
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  colSpan={2}
                                  sx={{
                                    backgroundColor: "rgba(51, 129, 155, 0.59)",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: "100%",
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Typography
                                      variant="h7"
                                      fontWeight="bold"
                                      gutterBottom
                                      align="center"
                                      sx={{
                                        fontWeight: "bold",
                                        color: "black",
                                        padding: "0.5vw 1vw",
                                        borderRadius: "8px",
                                        display: "inline-block",
                                        marginTop: "0vw",
                                      }}
                                    >
                                      Indicaciones de estabilidad
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell colSpan={5}>
                                  <ReactQuill
                                    theme="snow"
                                    value={etiqueta.indicacionesEstabilidad}
                                    readOnly={viewOnly}
                                    onChange={(content) =>
                                      handleChangeEtiqueta(
                                        index,
                                        "indicacionesEstabilidad",
                                        content,
                                      )
                                    }
                                    style={{
                                      minHeight: "8vh",
                                      height: "auto",
                                      width: "auto",
                                      color: viewOnly ? "gray" : "black",
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            </>
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={7}
                                align="center"
                                sx={{ py: 4 }}
                              >
                                No hay registros
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </React.Fragment>
                    ))}
                  </Table>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "0.5vw",
                    }}
                  >
                    <IconButton sx={{ color: "#006787" }} onClick={addEtiqueta}>
                      Añadir etiqueta
                      <AddIcon />
                    </IconButton>
                  </Box>
                </TabPanel>
                <TabPanel value={activeTabMuestras} index={1}>
                  <ReactQuill
                    theme="snow"
                    readOnly={viewOnly}
                    value={condicionesPx}
                    onChange={onCondicionesPxChangeRichText}
                    style={{
                      minHeight: "8vh",
                      height: "auto",
                      width: "auto",
                      color: viewOnly ? "gray" : "black",
                    }}
                  />
                </TabPanel>
              </Paper>
            </TabPanel>
          </Box>
        </Box>
        <Box
          sx={{
            position: "fixed",
            right: "6vw",
            top: "30%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {!viewOnly && (
            <Tooltip
              title={"Guardar estudio"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    fontFamily: "Roboto-Medium",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                onClick={agregarEstudio}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <SaveIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip
            title={"Nuevo estudio"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={reloadPage}
            >
              <AddIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={"Buscar estudio"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              onClick={mostrarBuscarEstudio}
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
            >
              <SearchIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={"Vista previa del estudio"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              onClick={() => mostrarPDF(selectedEstudioId)}
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
            >
              <RemoveRedEyeIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Content>
    </Layout>
  );
};
export default Estudios;
